<!-- Topbar Start -->
<div id="wrapper" [ngClass]="{'rl-dashboard': commonService.boardFlag, 'rl-section': commonService.homeFlag}">

  <!-- Modern header (board list + section view) -->
  <header class="header-style-rl" *ngIf="commonService.boardFlag || commonService.homeFlag">
    <a class="header-brand" href="javascript:void(0)" aria-label="realboard home"
      (click)="commonService.homeFlag && boardClick()">
      <img src="assets/images/realboard.svg" alt="RealBoard">
      <div class="header-brand-text">
        <span class="header-brand-name">RealBoard</span>
      </div>
    </a>

    <label class="header-search" for="header-search-input" *ngIf="commonService.boardFlag">
      <span class="material-symbols-outlined header-search-icon" aria-hidden="true">search</span>
      <input
        id="header-search-input"
        type="search"
        [placeholder]="'gameLabel.Search_boards' | translate"
        autocomplete="off"
        [(ngModel)]="boardSearch"
        [ngModelOptions]="{standalone: true}"
      />
      <kbd class="header-search-kbd">⌘K</kbd>
    </label>

    <ul class="header-actions">
      <li class="notification-list topbar-dropdown" ngbDropdown (click)="getNotification()">
        <a class="header-icon-btn" role="button" ngbDropdownToggle
          [attr.aria-label]="'gameLabel.All_Notification' | translate">
          <span class="material-symbols-outlined" aria-hidden="true">notifications</span>
          <span class="header-notif-badge" *ngIf="boardService.notificationCount > 0">{{ boardService.notificationCount }}</span>
        </a>
        <div class="dropdown-menu-end dropdown-lg header-dropdown" ngbDropdownMenu>
          <div class="header-dropdown-head">
            <span class="material-symbols-outlined" aria-hidden="true">notifications</span>
            <h5>{{ "gameLabel.All_Notification" | translate }}</h5>
          </div>
          <div class="header-dropdown-body">
            <ngx-simplebar class="noti-scroll" *ngIf="boardService.allNotifications.length > 0">
              <a class="header-notif-item" *ngFor="let item of boardService.allNotifications; let i = index" ngbDropdownItem>
                <span class="header-notif-avatar">
                  {{ getInitials(item.user_info?.name) }}
                </span>
                <div class="header-notif-copy">
                  <p class="header-notif-title">{{ item.title }}</p>
                  <p class="header-notif-time">{{ commonService.calculateHours(item.created_date) }}</p>
                  <div class="header-notif-actions">
                    <button class="header-notif-btn danger" type="button" *ngIf="item.type === 'info'"
                      (click)="updateNotification('delete', item)">
                      {{ "gameLabel.Delete" | translate }}
                    </button>
                    <button class="header-notif-btn primary" type="button" *ngIf="item.type === 'invite'"
                      (click)="updateNotification('accept', item)">
                      {{ "gameLabel.Accept" | translate }}
                    </button>
                    <button class="header-notif-btn danger" type="button" *ngIf="item.type === 'invite'"
                      (click)="updateNotification('delete', item)">
                      {{ "gameLabel.Decline" | translate }}
                    </button>
                  </div>
                </div>
              </a>
            </ngx-simplebar>
            <div class="header-dropdown-empty" *ngIf="boardService.allNotifications.length === 0">
              <span class="material-symbols-outlined" aria-hidden="true">notifications_off</span>
              <p>{{ 'gameLabel.no_noti' | translate }}</p>
            </div>
          </div>
        </div>
      </li>

      <li class="topbar-dropdown" ngbDropdown>
        <a class="header-icon-btn" role="button" ngbDropdownToggle aria-label="Language">
          <span class="material-symbols-outlined" aria-hidden="true">language</span>
        </a>
        <div class="dropdown-menu-end header-dropdown header-dropdown-sm" ngbDropdownMenu>
          <div class="header-dropdown-head">
            <span class="material-symbols-outlined" aria-hidden="true">language</span>
            <h5>{{ 'gameLabel.Language' | translate }}</h5>
          </div>
          <div class="header-dropdown-body header-lang-list">
            <button class="header-lang-item" type="button" ngbDropdownItem
              *ngFor="let language of translationService.languages"
              [class.is-active]="translationService.currentSelectedlang?.code === language.code"
              (click)="setSelectedLang(language.code)">
              <span>{{ language.name }}</span>
              <span class="material-symbols-outlined" aria-hidden="true"
                *ngIf="translationService.currentSelectedlang?.code === language.code">check</span>
            </button>
          </div>
        </div>
      </li>

      <li>
        <a class="header-icon-btn" role="button" (click)="commonService.toggleTheme()"
          [attr.aria-label]="commonService.isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'">
          <span class="material-symbols-outlined" aria-hidden="true">{{ commonService.isDarkMode ? 'light_mode' : 'dark_mode' }}</span>
        </a>
      </li>

      <li class="dropdown notification-list topbar-dropdown" ngbDropdown>
        <a ngbDropdownToggle class="header-profile" id="profileMenuDropdown" aria-expanded="false" aria-haspopup="menu">
          <span class="header-avatar">
            {{ getInitials(commonService.user?.name) }}
          </span>
          <span class="header-username">{{ commonService.user?.name }}</span>
          <span class="material-symbols-outlined header-chevron" aria-hidden="true">expand_more</span>
        </a>
        <div ngbDropdownMenu aria-labelledby="profileMenuDropdown"
          class="dropdown-menu-end header-dropdown header-dropdown-sm profile-dropdown">
          <div class="header-dropdown-profile">
            <span class="header-avatar">
              {{ getInitials(commonService.user?.name) }}
            </span>
            <div class="header-dropdown-profile-text">
              <span class="header-dropdown-welcome">{{ 'gameLabel.Welcome' | translate }}</span>
              <span class="header-dropdown-username">{{ commonService.user?.name }}</span>
            </div>
          </div>
          <div class="header-dropdown-body header-menu-list">
            <a class="header-menu-item" ngbDropdownItem data-bs-toggle="modal" data-bs-target="#profile">
              <span class="material-symbols-outlined" aria-hidden="true">person</span>
              <span>{{ 'gameLabel.My_Account' | translate }}</span>
            </a>
            <a class="header-menu-item" ngbDropdownItem (click)="logOut()">
              <span class="material-symbols-outlined" aria-hidden="true">logout</span>
              <span>{{ 'gameLabel.Logout' | translate }}</span>
            </a>
          </div>
        </div>
      </li>
    </ul>
  </header>

  <!-- end Topbar -->

  <!-- Left-bar -->
  <div class="left-side-menu side-menu-width">
    <ngx-simplebar class="h-100 simplebar-scrollable-y">
      <div class="simplebar-wrapper">
        <div class="simplebar-mask">
          <div class="simplebar-offset" style="right: 0px; bottom: 0px">
            <div class="simplebar-content-wrapper" style="height: 100%; overflow: hidden scroll">
              <div class="simplebar-content" style="padding: 0px">
                <div id="sidebar-menu">
                  <ul id="side-menu">
                    
                    <li class="addSectionLogoDis" data-bs-toggle="modal" data-bs-target="#addBoard">
                      <a class="side-nav-link-ref " *ngIf="commonService.boardFlag">
                        <i class=" fa-solid fa-plus-square sideBarLogo addSectionLogo"></i>
                        <p class="font-9 text-center">{{'gameLabel.Add_board'|translate}}</p>
                      </a>
                    </li>

                    <li (click)="boardClick()" *ngIf="commonService.homeFlag" >
                      <a class="side-nav-link-ref">
                        <i class="fa-solid fa-house"></i>
                      </a>
                    </li>
                    <li *ngIf="commonService.homeFlag &&commonService.user.drole!=='Gamer'" style="list-style: none;">
                      <a class="side-nav-link-ref  text-black addSectionLogoDis" role="button"  data-bs-toggle="modal" (click)="clickFilter()"
                      data-bs-target="#filterOption">
                        <i class="fe-filter noti-icon"></i>
                      </a>
                    </li> 
                    <li class="notification-list topbar-dropdown addSectionLogoDis" style="list-style: none;"
                    *ngIf="commonService.homeFlag  && (commonService.user.drole==='Teacher' ||commonService.user.drole==='School Admin')">
                    <a class="side-nav-link-ref text-black addSectionLogoDis" role="button" data-bs-toggle="modal"
                      data-bs-target="#inviteUser">
                      <i class="fe-user-plus noti-icon"></i>
                    </a>
                  </li> 

                    <li class="addSectionLogoDis" data-bs-toggle="modal" data-bs-target="#addSection">
                      <a class="side-nav-link-ref " *ngIf="commonService.homeFlag">
                        <i class=" fa-solid fa-plus-square sideBarLogo addSectionLogo"></i>
                        <p class="font-9 text-center">{{'gameLabel.Add_section'|translate}}</p>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ngx-simplebar>
  </div>
  <!-- Left-bar-end -->

  <!-- Middle-content -->
  <!-- <div id="wrapper"> -->
  <div class="{{leftBarHideClass}} {{boardService.scrollClass}} mainPageBackground {{goBoardHt}} ">
    <div class="content">
      <div class="container-fluid" >
        <!-- view board -->
        <div *ngIf="commonService.boardFlag" class="main-section-style-rl">
          <div class="user-section-style">
            <div class="label-user-welcome">
              <div class="user-enebled-section">
                <h1 class="title-welcome-text">
                  {{ 'gameLabel.Welcome_back' | translate: { name: getFirstName(commonService.user?.name) } }}
                </h1>
                <p class="desc-welcome-text">{{ 'gameLabel.Welcome_subtitle' | translate }}</p>
              </div>
              <div class="welcome-actions">
                <li ngbDropdown style="list-style: none;" class="addSectionBtnDis"
                  *ngIf="(boardFilterType==='other' || commonService.user.drole==='Gamer') && allBoard.length > 0">
                  <a class="welcome-filter-btn" role="button" ngbDropdownToggle>
                    <span class="material-symbols-outlined" aria-hidden="true">filter_list</span>
                  </a>
                  <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                    <div class="dropdown-divider"></div>
                    <button class="dropdown-item" (click)="boardFilterType='all'" *ngIf="commonService.user.drole==='Gamer'">
                      <span>{{ 'gameLabel.All' | translate }}</span>
                    </button>
                    <button class="dropdown-item" (click)="boardFilterType='own'" *ngIf="commonService.user.drole==='Gamer'">
                      <span>{{ 'gameLabel.Own' | translate }}</span>
                    </button>
                    <button class="dropdown-item" (click)="boardFilterType='invite'">
                      <span>{{ 'gameLabel.Invited' | translate }}</span>
                    </button>
                    <button class="dropdown-item" (click)="boardFilterType='system-generated'">
                      <span>{{ 'gameLabel.System-generated' | translate }}</span>
                    </button>
                  </div>
                </li>
                <li ngbDropdown style="list-style: none;" class="addSectionBtnDis"
                  *ngIf="boardFilterType!=='assignment' && commonService.user.drole!=='Gamer' && allBoard.length > 0">
                  <a class="welcome-filter-btn" role="button" ngbDropdownToggle>
                    <span class="material-symbols-outlined" aria-hidden="true">filter_list</span>
                  </a>
                  <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                    <div class="dropdown-divider"></div>
                    <button class="dropdown-item" (click)="boardFilterType='all'">
                      <span>{{ 'gameLabel.All' | translate }}</span>
                    </button>
                    <button class="dropdown-item" (click)="boardFilterType='own'">
                      <span>{{ 'gameLabel.Own' | translate }}</span>
                    </button>
                    <button class="dropdown-item" (click)="boardFilterType='invite'">
                      <span>{{ 'gameLabel.Invited' | translate }}</span>
                    </button>
                    <button class="dropdown-item" (click)="boardFilterType='system-generated'">
                      <span>{{ 'gameLabel.System-generated' | translate }}</span>
                    </button>
                  </div>
                </li>
                <button type="button" class="add-board-button addSectionBtnDis"
                  data-bs-toggle="modal" data-bs-target="#addBoard">
                  + {{ 'gameLabel.Add_Board' | translate }}
                </button>
              </div>
            </div>

            <div class="switch-button-box" role="tablist" aria-label="Board type"
              *ngIf="commonService.user.drole!=='Gamer'">
              <button
                class="switch-tab"
                [class.is-active]="toggleClassAssignment === 'activeBoard'"
                [class.activeBoard]="toggleClassAssignment === 'activeBoard'"
                [class.switch]="toggleClassAssignment !== 'activeBoard'"
                type="button"
                role="tab"
                [attr.aria-selected]="toggleClassAssignment === 'activeBoard'"
                (click)="toggle(1)">
                {{ 'gameLabel.Assignment' | translate }}
              </button>
              <button
                class="switch-tab"
                [class.is-active]="toggleClassPersonal === 'activeBoard'"
                [class.activeBoard]="toggleClassPersonal === 'activeBoard'"
                [class.switch]="toggleClassPersonal !== 'activeBoard'"
                type="button"
                role="tab"
                [attr.aria-selected]="toggleClassPersonal === 'activeBoard'"
                (click)="toggle(2)">
                {{ 'gameLabel.Personal' | translate }}
              </button>
            </div>
          </div>

          <div class="creating-card-container">
            <div *ngIf="(allBoard | filterByType: {type: boardFilterType, userId: commonService.user.id}
              | boardFilter: boardSearch).length === 0" class="dashboard-empty">
              <h2>{{ 'gameLabel.No_board' | translate }}</h2>
            </div>

            <article class="card-label-container" *ngFor="let board of allBoard
              | filterByType: {type: boardFilterType, userId: commonService.user.id}
              | boardFilter: boardSearch; let i = index">
              <div class="top-card-style">
                <div class="label-inner-1">
                  <div class="card-title-row">
                    <div class="icon-box" [class.labelp-2-icon]="board.type !== 'assignment'">
                      <span class="material-symbols-outlined" aria-hidden="true">
                        {{ board.type === 'assignment' ? 'group' : 'partner_heart' }}
                      </span>
                    </div>
                    <div class="label-2-content">
                      <h2 class="title-main-create"
                        [innerHTML]="commonService.getSanitizeHtml(board.name)"></h2>
                      <span class="assignment-topic-style"
                        [class.assignment-2-style]="board.type !== 'assignment'"
                        *ngIf="board.tag">{{ board.tag }}</span>
                    </div>
                  </div>
                  <div ngbDropdown>
                    <button class="more-vert-btn" type="button" ngbDropdownToggle
                      aria-label="More options">
                      <span class="material-symbols-outlined more-vert-icon">more_vert</span>
                    </button>
                    <div class="dropdown-menu-end header-dropdown header-dropdown-sm card-menu" ngbDropdownMenu>
                      <div class="header-dropdown-body header-menu-list">
                        <a class="header-menu-item" ngbDropdownItem (click)="selectedBoard(board.board_id,board)"
                          *ngIf="board.users_visiblity.includes('board-view')">
                          <span class="material-symbols-outlined">visibility</span>
                          {{ "gameLabel.View" | translate }}
                        </a>
                        <a class="header-menu-item" ngbDropdownItem (click)="editBoard(board)" data-bs-toggle="modal"
                          data-bs-target="#editBoard" *ngIf="board.users_visiblity.includes('board-edit')">
                          <span class="material-symbols-outlined">edit</span>
                          {{ "gameLabel.Edit" | translate }}
                        </a>
                        <a class="header-menu-item is-danger" ngbDropdownItem
                          (click)="deleteBoardConfirm(board.board_id,board.type)"
                          *ngIf="board.users_visiblity.includes('board-edit') && board.type!=='assignment' && board.section_count===0">
                          <span class="material-symbols-outlined">delete</span>
                          {{ "gameLabel.Delete" | translate }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="board-card-desc" *ngIf="getBoardDescText(board) as boardDesc">
                  {{ boardDesc | truncate: 110 }}
                </p>

                <div class="assignment-date-container" *ngIf="board.type === 'assignment' && board.user_info?.class_info">
                  <div class="assignment-label-box">
                    <p class="meta-label">{{ 'gameLabel.Assignment_name' | translate }}</p>
                    <p class="meta-value">{{ board.user_info.class_info.assignment_name }}</p>
                  </div>
                  <div class="date-label-box">
                    <p class="meta-label">{{ 'gameLabel.Created_on' | translate }}</p>
                    <p class="meta-value meta-date">
                      <span class="material-symbols-outlined date-icon" aria-hidden="true">calendar_month</span>
                      {{ board.user_info.class_info.start_date }}
                    </p>
                  </div>
                </div>

                <div class="total-card-section">
                  <div class="stat-box stat-sections">
                    <div class="stat-icon-box">
                      <span class="material-symbols-outlined" aria-hidden="true">description</span>
                    </div>
                    <div class="stat-text">
                      <span class="meta-label">{{ 'gameLabel.Total_Sections' | translate }}</span>
                      <span class="stat-number">{{ board.section_count }}</span>
                    </div>
                  </div>
                  <div class="stat-box stat-cards">
                    <div class="stat-icon-box">
                      <span class="material-symbols-outlined" aria-hidden="true">layers</span>
                    </div>
                    <div class="stat-text">
                      <span class="meta-label">{{ 'gameLabel.Total_cards' | translate }}</span>
                      <span class="stat-number">{{ board.card_count }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="bottom-card-style">
                <div class="owner-and-view-section">
                  <div class="card-owner-block">
                    <div class="owner-info">
                      <span class="owner-avatar">
                        {{ getInitials(board.user_info?.name) }}
                      </span>
                      <div class="owner-text">
                        <span class="owner-name">{{ board.user_info?.name }}</span>
                        <span class="owner-role">{{ 'gameLabel.Owner' | translate }}</span>
                      </div>
                    </div>
                    <div class="card-created-on" *ngIf="board.created_date">
                      <span class="material-symbols-outlined" aria-hidden="true">calendar_month</span>
                      <span class="card-created-on-label">{{ 'gameLabel.Created_on' | translate }}</span>
                      <span class="card-created-on-value">{{ board.created_date | date }}</span>
                    </div>
                  </div>
                  <a class="view-board-btn" href="javascript:void(0)"
                    (click)="selectedBoard(board.board_id, board)">
                    {{ 'gameLabel.View_Board' | translate }}
                    <span class="material-symbols-outlined" aria-hidden="true">arrow_forward</span>
                  </a>
                </div>
              </div>
            </article>
          </div>

        </div>
        <!-- view board end -->

        <!-- view section -->
        <div *ngIf="commonService.homeFlag" class="board-app">
          <div class="board-meta">
            <div class="board-meta-main">
              <div class="board-meta-icon" aria-hidden="true">
                <span class="material-symbols-outlined">dashboard</span>
              </div>
              <div class="board-meta-copy">
                <div class="board-meta-title-row">
                  <h1 class="board-title"
                    [innerHTML]="commonService.getSanitizeHtml(commonService.removeHTMLTags(boardService.activeBoardName))"></h1>
                  <span class="sections-count-pill">
                    <span class="material-symbols-outlined" aria-hidden="true">view_column</span>
                    {{ boardService.section.length }}
                    {{ 'gameLabel.Total_sections' | translate }}
                  </span>
                </div>
                <p class="board-meta-desc" *ngIf="boardService.activeBoardDesc">
                  {{ boardService.activeBoardDesc | truncate: 160 }}
                </p>
              </div>
            </div>

            <div class="board-meta-right">
              <button class="icon-btn" type="button" aria-label="Home" (click)="boardClick()">
                <span class="material-symbols-outlined">home</span>
              </button>
              <button class="icon-btn" type="button" aria-label="Filter"
                data-bs-toggle="modal" data-bs-target="#filterOption" (click)="clickFilter()">
                <span class="material-symbols-outlined">filter_list</span>
              </button>
              <button class="icon-btn" type="button" aria-label="Invite"
                *ngIf="commonService.user.drole==='Teacher' || commonService.user.drole==='School Admin'"
                data-bs-toggle="modal" data-bs-target="#inviteUser">
                <span class="material-symbols-outlined">person_add</span>
              </button>
              <button class="add-section-btn addSectionBtnDis" type="button"
                *ngIf="boardService.sectionCreateEdit"
                data-bs-toggle="modal" data-bs-target="#addSection">
                + {{'gameLabel.Add_Section'|translate}}
              </button>
            </div>
          </div>

          <div class="creating-card-container" id="sections-scroll" #scrollableDiv>
            <section class="board-column"
              *ngFor="let section of boardService.section | filter: searchText; let i = index"
              [ngStyle]="{'--section-color': getSectionColor(section)}">
              <div class="column-header">
                <p [class.blink]="boardService.isBlinking"
                  *ngIf="boardService.textBlink!=='' && boardService.changeSectionId===section.sectionId">
                  {{boardService.textBlink}}
                </p>
                <div class="column-title-row">
                  <h2>
                    <span [innerHTML]="commonService.getSanitizeHtml(section.sectionName)"></span>
                  </h2>
                  <div class="column-title-actions">
                    <button class="icon-btn sm" type="button" (click)="expandSection(section, i)"
                      [attr.aria-label]="'gameLabel.Expand' | translate">
                      <span class="material-symbols-outlined">open_in_full</span>
                    </button>
                  <div ngbDropdown>
                    <button class="icon-btn sm" type="button" ngbDropdownToggle aria-label="More">
                      <span class="material-symbols-outlined">more_vert</span>
                    </button>
                    <div class="dropdown-menu-end header-dropdown header-dropdown-sm card-menu" ngbDropdownMenu>
                      <div class="header-dropdown-body header-menu-list">
                        <a class="header-menu-item" ngbDropdownItem (click)="expandSection(section, i)">
                          <span class="material-symbols-outlined">open_in_full</span>
                          {{'gameLabel.Expand'|translate}}
                        </a>
                        <a class="header-menu-item" ngbDropdownItem (click)="getsectionId(section.sectionId,i)"
                          *ngIf="boardService.cardCreateEdit" data-bs-toggle="modal"
                          data-bs-target="#addCard">
                          <span class="material-symbols-outlined">add</span>
                          {{'gameLabel.Add_Card'|translate}}
                        </a>
                        <a class="header-menu-item" ngbDropdownItem (click)="viewSection(section)"
                          *ngIf="boardService.sectionView">
                          <span class="material-symbols-outlined">visibility</span>
                          {{'gameLabel.View'|translate}}
                        </a>
                        <a class="header-menu-item" ngbDropdownItem (click)="updateSection(section)"
                          *ngIf="boardService.sectionCreateEdit">
                          <span class="material-symbols-outlined">edit</span>
                          {{'gameLabel.Edit'|translate}}
                        </a>
                        <a class="header-menu-item is-danger" ngbDropdownItem (click)="deleteSectionConfirm(section.sectionId)"
                          *ngIf="boardService.sectionCreateEdit && section.cards.length===0">
                          <span class="material-symbols-outlined">delete</span>
                          {{'gameLabel.Delete'|translate}}
                        </a>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>

                <div class="column-desc">
                  <span class="column-desc-text" [class.column-desc-empty]="!getSectionDescText(section)">
                    {{ (getSectionDescText(section) || ('gameLabel.No_description' | translate)) | truncate: 95 }}
                  </span>
                  <button class="see-more-link" type="button" (click)="viewSection(section)"
                    *ngIf="getSectionDescText(section).length > 95">
                    {{ 'gameLabel.See_more' | translate }}
                  </button>
                </div>

                <div class="column-author">
                  <span class="avatar sm">
                    {{ getInitials(section.user_info?.name) }}
                  </span>
                  <span>{{ section.user_info?.name }}</span>
                  <span class="cards-count">{{ 'gameLabel.Cards' | translate }}: {{ section.cards?.length || 0 }}</span>
                </div>
              </div>

              <button class="add-card-btn" type="button"
                (click)="getsectionId(section.sectionId,i)" *ngIf="boardService.cardCreateEdit"
                data-bs-toggle="modal" data-bs-target="#addCard">
                + {{'gameLabel.Add_Card'|translate}}
              </button>

              <div class="column-cards">
                <article class="inner-card" *ngFor="let card of section.cards | filter: searchText; let j = index"
                  [class]="card.cardAnimationClass"
                  [ngClass]="{'borderCla': card.cardId === commonService.cardId, 'is-clickable': boardService.cardView}"
                  (click)="onCardSurfaceClick($event, card, section.sectionName)">
                  <div class="inner-card-top">
                    <div class="inner-card-user">
                      <span class="avatar sm">
                        {{ getInitials(card.user_info?.name) }}
                      </span>
                      <span class="user-name">{{card.user_info?.name}}</span>
                      <span class="time">{{ commonService.calculateHours(card.cardCreatedDate) }}</span>
                    </div>
                    <div ngbDropdown (click)="$event.stopPropagation()">
                      <button class="icon-btn sm" type="button" ngbDropdownToggle aria-label="More">
                        <span class="material-symbols-outlined">more_vert</span>
                      </button>
                      <div class="dropdown-menu-end header-dropdown header-dropdown-sm card-menu" ngbDropdownMenu>
                        <div class="header-dropdown-body header-menu-list">
                          <a class="header-menu-item" ngbDropdownItem *ngIf="boardService.cardView"
                            (click)="viewCard(card,section.sectionName)">
                            <span class="material-symbols-outlined">visibility</span>
                            {{'gameLabel.View'|translate}}
                          </a>
                          <a class="header-menu-item" ngbDropdownItem
                            *ngIf="boardService.cardCreateEdit && card.user_info.id===commonService.user.id"
                            (click)="editCardDir(card,section.sectionName)">
                            <span class="material-symbols-outlined">edit</span>
                            {{'gameLabel.Edit'|translate}}
                          </a>
                          <a class="header-menu-item is-danger" ngbDropdownItem
                            *ngIf="boardService.cardCreateEdit && card.user_info.id===commonService.user.id && card.cardComment.length===0 && card.reactions.length===0"
                            (click)="deleteCardConfirm(card.cardId,section.sectionId)">
                            <span class="material-symbols-outlined">delete</span>
                            {{'gameLabel.Delete'|translate}}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="social-media-container" *ngIf="card.thumbnail.length>0"
                    data-toggle="modal" data-target="#screenshotView"
                    (click)="clickThumbnail(card.thumbnail[0].url)">
                    <img [src]="card.thumbnail[0].url" alt="" class="inner-card-media pointer">
                  </div>

                  <h3 class="inner-card-title"
                    [innerHTML]="commonService.getSanitizeHtml(card.cardTitle)"></h3>
                  <p class="inner-card-desc">
                    <span class="inner-card-desc-text">{{ getCardDescText(card) | truncate: 220 }}</span>
                    <span class="see-more-link"
                      *ngIf="getCardDescText(card).length > 220"> {{'gameLabel.See_more'|translate}}</span>
                  </p>

                  <div class="sdg-logo-container" *ngIf="card.sdg_tags.length>0" data-toggle="modal"
                    data-target="#sdgImagView" (click)="sdgView(card.sdg_tags)" style="cursor: pointer;">
                    <div class="logo-sdg" *ngFor="let sdg of card.sdg_tags">
                      <img src="assets/images/sdgicon/sdg{{sdg}}_{{commonService.selectedlang}}.png" alt="">
                    </div>
                  </div>

                  <div class="card-media-container" *ngIf="card.media.length>0">
                    <div class="media-container">
                      <div class="media-box mt-2" *ngFor="let media of card.media">
                        <img class="inner-card-media pointer" *ngIf="media.type==='image' || media.type==='webimage'"
                          (click)="setDefaultMedia(card.media,media.name, getCardAuthorName(card))" [src]="media.url" alt="">
                        <iframe class="inner-card-media pointer" *ngIf="media.type==='webvideo'"
                          (click)="setDefaultMedia(card.media,media.name, getCardAuthorName(card))"
                          [src]="'https://www.youtube.com/embed/' + media.url|safe" title="videonew"></iframe>
                        <video class="inner-card-media pointer" *ngIf="media.type==='video'" [src]="media.url"
                          (click)="setDefaultMedia(card.media,media.name, getCardAuthorName(card))"></video>
                        <img class="pointer" *ngIf="media.type === 'csv'" src="assets/images/media/csv.svg"
                          (click)="setDefaultMedia(card.media,media.name, getCardAuthorName(card))" alt="csv" />
                        <img class="pointer" *ngIf="media.type === 'sheet'" src="assets/images/media/excel.svg"
                          (click)="setDefaultMedia(card.media,media.name, getCardAuthorName(card))" alt="xlsx" />
                        <img class="pointer" *ngIf="media.type === 'ppt'" src="assets/images/media/ppt.svg"
                          (click)="setDefaultMedia(card.media,media.name, getCardAuthorName(card))" alt="ppt" />
                        <img class="pointer" *ngIf="media.type === 'pdf'" src="assets/images/media/pdf.svg"
                          (click)="setDefaultMedia(card.media,media.name, getCardAuthorName(card))" alt="pdf" />
                        <button type="button" class="card-audio-tile" *ngIf="media.type === 'audio'"
                          (click)="setDefaultMedia(card.media,media.name, getCardAuthorName(card))">
                          <span class="card-audio-icon" aria-hidden="true">
                            <span class="material-symbols-outlined">graphic_eq</span>
                          </span>
                          <span class="card-audio-copy">
                            <span class="card-audio-label">{{ 'gameLabel.Audio' | translate }}</span>
                            <span class="card-audio-from">{{ 'gameLabel.Audio_from' | translate: { name: getCardAuthorName(card) } }}</span>
                          </span>
                          <span class="card-audio-play" aria-hidden="true">
                            <span class="material-symbols-outlined">play_arrow</span>
                          </span>
                        </button>
                        <audio #audioPlayer></audio>
                      </div>
                    </div>
                  </div>

                  <div class="inner-card-footer">
                    <div class="emotion-card-star-comment-count">
                      <div class="emotions-icon-containetr">
                        <div class="icon-box overlap-margin" *ngFor="let reaction of card.lastThreeReaction"
                          data-bs-toggle="modal" data-bs-target="#reactionModel" style="cursor: pointer;">
                          <span class="emogiFontDisplay text-center" *ngIf="reaction.type==='like'" (click)="reactionModel(card.reactions,card)">👍</span>
                          <span class="emogiFontDisplay text-center" *ngIf="reaction.type==='love'" (click)="reactionModel(card.reactions,card)">❤️</span>
                          <span class="emogiFontDisplay text-center" *ngIf="reaction.type==='haha'" (click)="reactionModel(card.reactions,card)">😂</span>
                          <span class="emogiFontDisplay text-center" *ngIf="reaction.type==='wow'" (click)="reactionModel(card.reactions,card)">😮</span>
                          <span class="emogiFontDisplay text-center" *ngIf="reaction.type==='sad'" (click)="reactionModel(card.reactions,card)">😢</span>
                          <span class="emogiFontDisplay text-center" *ngIf="reaction.type==='angry'" (click)="reactionModel(card.reactions,card)">😡</span>
                        </div>
                        <div class="icon-box overlap-right-plus" *ngIf="card.reactionCount>3"
                          data-bs-toggle="modal" data-bs-target="#reactionModel"
                          (click)="reactionModel(card.reactions,card)" style="cursor: pointer;">
                          <p *ngIf="card.reactionCount>3">+{{card.reactionCount}}</p>
                        </div>
                        <div class="icon-box overlap-margin {{card.reactionIconClass}}" (click)="clickReaction(card)">
                          <span class="material-symbols-outlined face">sentiment_satisfied</span>
                        </div>
                      </div>
                      <div *ngIf="boardService.assignmentId>0">
                        <ngb-rating [max]=5 [(rate)]="card.cardRating" [readonly]="true"
                          *ngIf="!boardService.cardRating"></ngb-rating>
                        <ngb-rating [max]=5 [(rate)]="card.cardRating"
                          (rateChange)="getValue(card,card.cardRating)"
                          *ngIf="boardService.cardRating"></ngb-rating>
                      </div>
                      <div class="second-popop-emotion" *ngIf="card.showReaction">
                        <div class="icon-box mojiFont text-center">
                          <span [class.selected]="selectedReaction === 'like'" (click)="setReaction('like',card)">👍</span>
                        </div>
                        <div class="icon-box mojiFont text-center">
                          <span [class.selected]="selectedReaction === 'love'" (click)="setReaction('love',card)">❤️</span>
                        </div>
                        <div class="icon-box mojiFont text-center">
                          <span [class.selected]="selectedReaction === 'haha'" (click)="setReaction('haha',card)">😂</span>
                        </div>
                        <div class="icon-box mojiFont text-center">
                          <span [class.selected]="selectedReaction === 'wow'" (click)="setReaction('wow',card)">😮</span>
                        </div>
                        <div class="icon-box mojiFont text-center">
                          <span [class.selected]="selectedReaction === 'sad'" (click)="setReaction('sad',card)">😢</span>
                        </div>
                        <div class="icon-box mojiFont text-center">
                          <span [class.selected]="selectedReaction === 'angry'" (click)="setReaction('angry',card)">😡</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <label class="comment-box">
                    <input type="text" [placeholder]="'gameLabel.Add_comment'|translate"
                      (ngModelChange)="onInputChange(card)"
                      [(ngModel)]="card.commentText"
                      (keyup.enter)="saveComment(card.commentText,card.cardId,card.cardComment.length,card.sectionId)">
                    <button type="button" aria-label="Send" [disabled]="!card.commentText"
                      (click)="saveComment(card.commentText,card.cardId,card.cardComment.length,card.sectionId)">
                      <span class="material-symbols-outlined">send</span>
                    </button>
                  </label>

                  <div class="rl-thread inner-card-comments" *ngIf="card.cardComment.length>0">
                    <div class="view-card-comments-head">
                      <h5>{{ 'gameLabel.Comment' | translate }}</h5>
                      <span class="view-card-comments-count">{{ card.cardComment.length }}</span>
                      <button class="inner-card-view-all" type="button"
                        data-bs-toggle="modal" data-bs-target="#commentModel"
                        (click)="viewAllComment(card)">
                        {{ 'gameLabel.View_all' | translate }}
                      </button>
                    </div>
                    <div class="view-card-comment-list">
                      <article class="view-card-comment" *ngFor="let comment of card.cardComment">
                        <span class="avatar sm">{{ getInitials(comment.name) }}</span>
                        <div class="view-card-comment-body">
                          <div class="view-card-comment-meta">
                            <strong>{{ comment.name }}</strong>
                            <time>{{ commonService.calculateHours(comment.id) }}</time>
                            <div class="view-card-comment-actions"
                              *ngIf="comment.user_id===commonService.userId && !comment.editCommentFlag">
                              <button type="button" (click)="editClick(comment)"
                                [attr.aria-label]="'gameLabel.Edit' | translate">
                                <span class="material-symbols-outlined">edit</span>
                              </button>
                              <button type="button" class="is-danger"
                                (click)="deleteCommentConfirm(card.cardId,comment.id,card.sectionId)"
                                [attr.aria-label]="'gameLabel.Delete' | translate">
                                <span class="material-symbols-outlined">delete</span>
                              </button>
                            </div>
                          </div>
                          <p class="view-card-comment-text" *ngIf="!comment.editCommentFlag">{{ comment.text }}</p>
                          <div class="view-card-comment-editor"
                            *ngIf="comment.editCommentFlag && editCommentId===comment.id">
                            <input type="text" [(ngModel)]="editCommentText"
                              [placeholder]="'gameLabel.Add_comment' | translate"
                              (keyup.enter)="editComment(card.cardId,card.sectionId)">
                            <button type="button" (click)="cancelEditComment(comment)" aria-label="Cancel">
                              <span class="material-symbols-outlined">close</span>
                            </button>
                            <button type="button" class="is-save"
                              (click)="editComment(card.cardId,card.sectionId)"
                              [disabled]="comment.text===editCommentText || editCommentText===''">
                              <span class="material-symbols-outlined">check</span>
                            </button>
                          </div>
                        </div>
                      </article>
                    </div>
                  </div>
                </article>
              </div>
            </section>
          </div>

          <div class="section-nav" *ngIf="boardService.section.length >= 3">
            <button type="button" aria-label="Previous sections" (click)="scrollSectionsBy(-340)">
              <span class="material-symbols-outlined">chevron_left</span>
            </button>
            <button type="button" aria-label="Next sections" (click)="scrollSectionsBy(340)">
              <span class="material-symbols-outlined">chevron_right</span>
            </button>
          </div>
        </div>

        <!-- view section end -->
      </div>
    </div>

  </div>

</div>
<!-- Middle-content-end -->

<!-- Add board model -->
<div class="modal fade" id="addBoard" tabindex="-1" aria-labelledby="addBoardLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="container-add-popup">
        <header class="header-style-add-board">
          <div class="title-id-content">
            <div class="icon-board-label">
              <span class="material-symbols-outlined">dashboard</span>
            </div>
            <div class="title-desc-board">
              <h4 class="title-add-board" id="addBoardLabel">{{ "gameLabel.Add_board" | translate }}</h4>
              <p class="description-title-add-board">{{ "gameLabel.Add_board_subtitle" | translate }}</p>
            </div>
          </div>
          <button class="cancel-icon-board" type="button" data-bs-dismiss="modal" aria-label="Close"
            (click)="emptyAllFields()">
            <span class="icon-cancel">
              <span class="material-symbols-outlined">close</span>
            </span>
          </button>
        </header>

        <div class="content-board-modal">
          <div class="user-board-name-structure">
            <p class="board-name-label">
              {{ "gameLabel.Board_Name" | translate }}
              <span class="permanent-color-star">*</span>
            </p>
            <div class="placeholader-container">
              <div class="icon-palc" aria-hidden="true">Aa</div>
              <input type="text" [(ngModel)]="boardName"
                [placeholder]="'gameLabel.Board_Name' | translate"
                maxlength="50" />
            </div>
          </div>

          <div class="board-description">
            <p class="board-name-label">
              {{ "gameLabel.board_description" | translate }}
            </p>
            <div class="board-description-structure rl-rich-editor">
              <div class="rl-desc-toolbar" role="toolbar" aria-label="Description formatting">
                <button type="button" class="rl-desc-btn" title="Bold"
                  (mousedown)="$event.preventDefault()" (click)="applyDescFormat('bold')">
                  <strong>B</strong>
                </button>
                <button type="button" class="rl-desc-btn" title="Italic"
                  (mousedown)="$event.preventDefault()" (click)="applyDescFormat('italic')">
                  <em>I</em>
                </button>
                <button type="button" class="rl-desc-btn" title="Underline"
                  (mousedown)="$event.preventDefault()" (click)="applyDescFormat('underline')">
                  <span class="rl-desc-u">U</span>
                </button>
              </div>
              <div class="rl-desc-input"
                contenteditable="true"
                role="textbox"
                aria-multiline="true"
                [attr.data-placeholder]="'gameLabel.board_description' | translate"
                [class.is-empty]="!commonService.removeHTMLTags(boardDescription)?.trim()"
                (input)="onBoardDescInput($event)"
                #boardDescEditor></div>
            </div>
          </div>
        </div>

        <div class="footer-add-board-container">
          <button class="cancel-btn-board" type="button" data-bs-dismiss="modal" (click)="emptyAllFields()">
            {{ "gameLabel.Cancel" | translate }}
          </button>
          <button class="add-btn-board" type="button" data-bs-dismiss="modal"
            [disabled]="!commonService.removeHTMLTags(boardName).trim()"
            (click)="addBoard()">
            <span class="material-symbols-outlined">add</span>
            {{ "gameLabel.Add_board" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Add board model end -->

<!-- Add section model -->
<div class="modal fade" id="addSection" tabindex="-1" aria-labelledby="addSectionLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="container-section-main">
        <header class="header-style-add-board">
          <div class="title-id-content">
            <div class="icon-board-label">
              <span class="material-symbols-outlined">dashboard</span>
            </div>
            <div class="title-desc-board">
              <h4 class="title-add-board" id="addSectionLabel">
                {{ "gameLabel.Add_Section_publish" | translate }}
                <span [innerHTML]="commonService.getSanitizeHtml(commonService.removeHTMLTags(boardService.activeBoardName))"></span>
              </h4>
              <p class="description-title-add-board">{{ "gameLabel.Add_section_subtitle" | translate }}</p>
            </div>
          </div>
          <button class="cancel-icon-board" type="button" data-bs-dismiss="modal" aria-label="Close"
            (click)="emptyAllFields()">
            <span class="icon-cancel">
              <span class="material-symbols-outlined">close</span>
            </span>
          </button>
        </header>

        <div class="section-modal-body">
          <div class="select-color-user-data">
            <p class="section-field-label">{{'gameLabel.Select_section_color'|translate}}</p>
            <div class="section-color-row" role="listbox" aria-label="Section color">
              <button class="color-swatch" type="button" *ngFor="let swatch of sectionColorSwatches"
                [style.--swatch]="swatch"
                [class.is-selected]="colourPickerService.selctedColor === swatch"
                [attr.aria-pressed]="colourPickerService.selctedColor === swatch"
                (click)="selectSectionColor(swatch)">
                <span class="material-symbols-outlined">check</span>
              </button>
            </div>

            <div class="section-field">
              <label class="section-field-label">{{ "gameLabel.Board_Name" | translate }}</label>
              <div class="section-input-box is-readonly">
                <span class="section-input-icon" aria-hidden="true">
                  <span class="material-symbols-outlined">dashboard</span>
                </span>
                <input type="text" readonly
                  [value]="commonService.removeHTMLTags(boardService.activeBoardName)" />
              </div>
            </div>

            <div class="section-field">
              <label class="section-field-label" for="section-name-input">
                {{ "gameLabel.Section_name" | translate }}
                <span class="permanent-color-star">*</span>
              </label>
              <div class="section-input-box">
                <span class="section-input-icon text-icon" aria-hidden="true">T</span>
                <input id="section-name-input" type="text"
                  [(ngModel)]="sectionName"
                  placeholder="Section title"
                  (click)="setActiveEditor('sectionCreateTitle', 1)"
                  maxlength="60" />
              </div>
            </div>

            <div class="section-field">
              <label class="section-field-label">
                {{ "gameLabel.Section_description" | translate }}
                <span class="permanent-color-star">*</span>
              </label>
              <div class="board-description-structure section-desc-editor rl-rich-editor">
                <div class="rl-desc-toolbar" role="toolbar" aria-label="Description formatting">
                  <button type="button" class="rl-desc-btn" title="Bold"
                    (mousedown)="$event.preventDefault()" (click)="applyDescFormat('bold')">
                    <strong>B</strong>
                  </button>
                  <button type="button" class="rl-desc-btn" title="Italic"
                    (mousedown)="$event.preventDefault()" (click)="applyDescFormat('italic')">
                    <em>I</em>
                  </button>
                  <button type="button" class="rl-desc-btn" title="Underline"
                    (mousedown)="$event.preventDefault()" (click)="applyDescFormat('underline')">
                    <span class="rl-desc-u">U</span>
                  </button>
                </div>
                <div class="rl-desc-input"
                  contenteditable="true"
                  role="textbox"
                  aria-multiline="true"
                  [attr.data-placeholder]="'gameLabel.Section_description' | translate"
                  [class.is-empty]="!commonService.removeHTMLTags(sectionDesc)?.trim()"
                  (input)="onSectionDescInput($event)"
                  #sectionDescEditor></div>
              </div>
            </div>
          </div>

          <div class="document-data-container">
            <div class="media-attach-heading">
              <h5>{{'gameLabel.Select_media'|translate}}</h5>
              <div class="media-size-limits">
                <span class="media-size-chip">
                  <span class="material-symbols-outlined">image</span>
                  {{ commonService.maxImageSize }}MB
                </span>
                <span class="media-size-chip">
                  <span class="material-symbols-outlined">videocam</span>
                  {{ commonService.maxVideoSize }}MB
                </span>
                <span class="media-size-chip">
                  <span class="material-symbols-outlined">mic</span>
                  {{ commonService.maxAudioSize }}MB
                </span>
                <span class="media-size-chip">
                  <span class="material-symbols-outlined">attach_file</span>
                  {{ commonService.maxFileSize }}MB
                </span>
              </div>
            </div>

            <div class="media-tabs" role="tablist" aria-label="Media type">
              <label class="media-tab" for="fileInputImageSection"
                [class.is-active]="sectionMediaTab==='image'"
                [class.disabled]="boardService.imageCount >= 1"
                (click)="sectionMediaTab='image'">
                <span class="material-symbols-outlined">image</span>
              </label>
              <input type="file" id="fileInputImageSection" class="file-upload" (change)="onSelectFileInput($event)"
                style="display: none" accept=".png, .jpeg,.jpg" />

              <label class="media-tab" for="fileInputVideoSection"
                [class.is-active]="sectionMediaTab==='video'"
                [class.disabled]="boardService.videoCount >= 1"
                (click)="sectionMediaTab='video'">
                <span class="material-symbols-outlined">videocam</span>
              </label>
              <input type="file" id="fileInputVideoSection" class="file-upload" (change)="onSelectFileInput($event)"
                style="display: none" accept=".mp4, .avi, .mov" />

              <button class="media-tab" type="button"
                [class.is-active]="sectionMediaTab==='audio'"
                [class.disabled]="boardService.audioCount >= 1"
                (click)="sectionMediaTab='audio'; startRecording()">
                <span class="material-symbols-outlined">mic</span>
              </button>

              <label class="media-tab" for="fileInputOtherSection"
                [class.is-active]="sectionMediaTab==='file'"
                [class.disabled]="boardService.fileCount >= 1"
                (click)="sectionMediaTab='file'">
                <span class="material-symbols-outlined">attach_file</span>
              </label>
              <input type="file" id="fileInputOtherSection" class="file-upload" (change)="onSelectFileInput($event)"
                style="display: none" accept=".pdf,.csv,.xlsx,.ppt,.pptx" />

              <button class="media-tab" type="button"
                [class.is-active]="sectionMediaTab==='search'"
                [class.disabled]="boardService.imageCount >= 1 && boardService.videoCount >= 1"
                (click)="sectionMediaTab='search'; openModal('webSearch')">
                <span class="material-symbols-outlined">search</span>
              </button>
            </div>

            <div class="media-upload-box">
              <ng-container *ngIf="uploadedFileArray.length === 0; else sectionMediaPreviews">
                <div class="media-preview">
                  <span class="material-symbols-outlined">image</span>
                </div>
                <div class="media-upload-text">
                  <p class="media-upload-title">{{ 'gameLabel.No_file_selected' | translate }}</p>
                  <p class="media-upload-hint">{{ 'gameLabel.Choose_or_drop_file' | translate }}</p>
                </div>
              </ng-container>
              <ng-template #sectionMediaPreviews>
                <div class="media-previews-row">
                  <div class="media-preview" *ngFor="let media of uploadedFileArray; let i = index">
                    <button class="media-remove-btn" type="button" aria-label="Remove file"
                      (click)="cancelMediaEdit(i, media.type)">
                      <span class="material-symbols-outlined">close</span>
                    </button>
                    <img *ngIf="media.type === 'image' || media.type === 'webimage'" [src]="media.displayUrl" alt="" />
                    <video *ngIf="media.type === 'video'" [src]="media.displayUrl"></video>
                    <iframe *ngIf="media.type === 'webvideo'"
                      [src]="'https://www.youtube.com/embed/' + media.displayUrl | safe" frameborder="0"></iframe>
                    <img *ngIf="media.type === 'csv'" src="assets/images/media/csv.svg" alt="csv" />
                    <img *ngIf="media.type === 'sheet'" src="assets/images/media/excel.svg" alt="xlsx" />
                    <img *ngIf="media.type === 'ppt'" src="assets/images/media/ppt.svg" alt="ppt" />
                    <img *ngIf="media.type === 'pdf'" src="assets/images/media/pdf.svg" alt="pdf" />
                    <div class="circular-player" (click)="togglePlay(media)" *ngIf="media.type === 'audio'">
                      <div class="player" [style.background]="progressStyle">
                        <div class="play-pause">{{ media.isPlaying ? "❚❚" : "►" }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="footer-section-modal">
          <button class="cancel-btn-board" type="button" data-bs-dismiss="modal" (click)="emptyAllFields()">
            {{ "gameLabel.Cancel" | translate }}
          </button>
          <button class="publish-section-btn" type="button" data-bs-dismiss="modal"
            [disabled]="!(commonService.removeHTMLTags(sectionName).trim() && commonService.removeHTMLTags(sectionDesc)?.trim())"
            (click)="addSection()">
            {{ "gameLabel.Publish" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Add section model end -->



<!-- Add card model -->
<div class="modal fade" id="addCard" tabindex="-1" aria-labelledby="addCardLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="container-modal-first">
        <header class="header-style-add-board">
          <div class="title-id-content">
            <div class="icon-board-label">
              <span class="material-symbols-outlined">credit_card</span>
            </div>
            <div class="title-desc-board">
              <h4 class="title-add-board" id="addCardLabel">
                {{ "gameLabel.Add_Card_publish" | translate }}
                <span [innerHTML]="commonService.getSanitizeHtml(commonService.removeHTMLTags(boardService.activeBoardName))"></span>
              </h4>
              <p class="description-title-add-board">{{ "gameLabel.Add_card_subtitle" | translate }}</p>
            </div>
          </div>
          <button class="cancel-icon-board" type="button" data-bs-dismiss="modal" aria-label="Close"
            (click)="emptyAllFields()">
            <span class="icon-cancel">
              <span class="material-symbols-outlined">close</span>
            </span>
          </button>
        </header>

        <div class="section-modal-body">
          <div class="select-color-user-data">
            <div class="section-field">
              <div class="section-input-box is-readonly flex-justify-style">
                <div class="label-start-style" *ngIf="boardService.boardType==='assignment'; else boardNameReadonly">
                  <span class="section-input-icon" aria-hidden="true">
                    <span class="material-symbols-outlined">assignment</span>
                  </span>
                  <span class="label-flex-style">
                    <label class="section-field-label margin-bottom-style">{{ "gameLabel.Assignment_name" | translate }}</label>
                    <input class="text-color-user-name" type="text" [value]="boardService.assignmentName" readonly />
                  </span>
                </div>
                <ng-template #boardNameReadonly>
                  <div class="label-start-style">
                    <span class="section-input-icon" aria-hidden="true">
                      <span class="material-symbols-outlined">credit_card</span>
                    </span>
                    <span class="label-flex-style">
                      <label class="section-field-label margin-bottom-style">{{ "gameLabel.Board_Name" | translate }}</label>
                      <input class="text-color-user-name" type="text" readonly
                        [value]="commonService.removeHTMLTags(boardService.activeBoardName)" />
                    </span>
                  </div>
                </ng-template>

                <div class="label-start-style">
                  <span class="section-input-icon" aria-hidden="true">
                    <span class="material-symbols-outlined">grid_4x4</span>
                  </span>
                  <span class="label-flex-style">
                    <label class="section-field-label margin-bottom-style">{{ "gameLabel.Section_name" | translate }}</label>
                    <input class="text-color-user-name" type="text" [value]="selectedSectionName" readonly />
                  </span>
                </div>
              </div>
            </div>

            <div class="section-field">
              <label class="section-field-label" for="card-name-input">
                {{ "gameLabel.Card_name" | translate }}
                <span class="permanent-color-star">*</span>
              </label>
              <div class="section-input-box">
                <span class="section-input-icon text-icon" aria-hidden="true">T</span>
                <input id="card-name-input" type="text" [(ngModel)]="cardName"
                  placeholder="Card title" maxlength="60"
                  (click)="setActiveEditor('addTitleCard', 5)" />
              </div>
            </div>

            <div class="section-field">
              <label class="section-field-label">
                {{ "gameLabel.Card_description" | translate }}
                <span class="permanent-color-star">*</span>
              </label>
              <div class="board-description-structure section-desc-editor rl-rich-editor">
                <div class="rl-desc-toolbar" role="toolbar" aria-label="Description formatting">
                  <button type="button" class="rl-desc-btn" title="Bold"
                    (mousedown)="$event.preventDefault()" (click)="applyDescFormat('bold')">
                    <strong>B</strong>
                  </button>
                  <button type="button" class="rl-desc-btn" title="Italic"
                    (mousedown)="$event.preventDefault()" (click)="applyDescFormat('italic')">
                    <em>I</em>
                  </button>
                  <button type="button" class="rl-desc-btn" title="Underline"
                    (mousedown)="$event.preventDefault()" (click)="applyDescFormat('underline')">
                    <span class="rl-desc-u">U</span>
                  </button>
                </div>
                <div class="rl-desc-input"
                  contenteditable="true"
                  role="textbox"
                  aria-multiline="true"
                  [attr.data-placeholder]="'gameLabel.Card_description' | translate"
                  [class.is-empty]="!commonService.removeHTMLTags(cardDesc)?.trim()"
                  (input)="onCardDescInput($event)"
                  #cardDescEditor></div>
              </div>
            </div>
          </div>

          <div class="container-content-data">
            <div class="attachment-data-container">
              <p class="title-attached-text">{{ 'gameLabel.Select_media' | translate }}</p>
              <div class="media-size-limits">
                <span class="media-size-chip">
                  <span class="material-symbols-outlined">image</span>
                  {{ commonService.maxImageSize }}MB
                </span>
                <span class="media-size-chip">
                  <span class="material-symbols-outlined">videocam</span>
                  {{ commonService.maxVideoSize }}MB
                </span>
                <span class="media-size-chip">
                  <span class="material-symbols-outlined">mic</span>
                  {{ commonService.maxAudioSize }}MB
                </span>
                <span class="media-size-chip">
                  <span class="material-symbols-outlined">attach_file</span>
                  {{ commonService.maxFileSize }}MB
                </span>
              </div>
              <div class="icon-container-box">
                <label class="icon-data-upload" for="fileInputImageCard"
                  [class.is-active]="cardMediaTab==='image'"
                  [class.disabled]="boardService.imageCount >= 1"
                  (click)="cardMediaTab='image'">
                  <span class="material-symbols-outlined">image</span>
                </label>
                <input type="file" id="fileInputImageCard" class="file-upload" (change)="onSelectFileInput($event)"
                  style="display: none" accept=".png, .jpeg,.jpg" />

                <label class="icon-data-upload" for="fileInputVideoCard"
                  [class.is-active]="cardMediaTab==='video'"
                  [class.disabled]="boardService.videoCount >= 1"
                  (click)="cardMediaTab='video'">
                  <span class="material-symbols-outlined">video_camera_back</span>
                </label>
                <input type="file" id="fileInputVideoCard" class="file-upload" (change)="onSelectFileInput($event)"
                  style="display: none" accept=".mp4, .avi, .mov" />

                <button class="icon-data-upload" type="button"
                  [class.is-active]="cardMediaTab==='audio'"
                  [class.disabled]="boardService.audioCount === 1"
                  (click)="cardMediaTab='audio'; startRecording()">
                  <span class="material-symbols-outlined">mic</span>
                </button>

                <label class="icon-data-upload" for="fileInputOtherCard"
                  [class.is-active]="cardMediaTab==='file'"
                  [class.disabled]="boardService.fileCount >= 1"
                  (click)="cardMediaTab='file'">
                  <span class="material-symbols-outlined">attachment</span>
                </label>
                <input type="file" id="fileInputOtherCard" class="file-upload" (change)="onSelectFileInput($event)"
                  style="display: none" accept=".pdf,.csv,.xlsx,.ppt,.pptx" />

                <button class="icon-data-upload" type="button"
                  [class.is-active]="cardMediaTab==='search'"
                  [class.disabled]="boardService.imageCount >= 1 && boardService.videoCount >= 1"
                  (click)="cardMediaTab='search'; openModal('webSearch')">
                  <span class="material-symbols-outlined">search</span>
                </button>
              </div>
            </div>

            <div class="media-upload-box"
              [class.is-picker]="uploadedFileArray.length === 0"
              [attr.role]="uploadedFileArray.length === 0 ? 'button' : null"
              [attr.tabindex]="uploadedFileArray.length === 0 ? 0 : null"
              [attr.aria-label]="uploadedFileArray.length === 0 ? ('gameLabel.Choose_or_drop_file' | translate) : null"
              (click)="openCardMediaPicker()"
              (keydown.enter)="openCardMediaPicker()"
              (keydown.space)="$event.preventDefault(); openCardMediaPicker()">
              <ng-container *ngIf="uploadedFileArray.length === 0; else cardMediaPreviews">
                <div class="media-preview">
                  <span class="material-symbols-outlined">image</span>
                </div>
                <div class="media-upload-text">
                  <p class="media-upload-title">{{ 'gameLabel.No_file_selected' | translate }}</p>
                  <p class="media-upload-hint">{{ 'gameLabel.Choose_or_drop_file' | translate }}</p>
                </div>
                <span class="material-symbols-outlined media-upload-affordance" aria-hidden="true">upload</span>
              </ng-container>
              <ng-template #cardMediaPreviews>
                <div class="media-previews-row">
                  <div class="media-preview" *ngFor="let media of uploadedFileArray; let i = index">
                    <button class="media-remove-btn" type="button" aria-label="Remove file"
                      (click)="cancelMediaEdit(i, media.type)">
                      <span class="material-symbols-outlined">close</span>
                    </button>
                    <img *ngIf="media.type === 'image' || media.type === 'webimage'" [src]="media.displayUrl" alt="" />
                    <video *ngIf="media.type === 'video'" [src]="media.displayUrl"></video>
                    <iframe *ngIf="media.type === 'webvideo'"
                      [src]="'https://www.youtube.com/embed/' + media.displayUrl | safe" frameborder="0"></iframe>
                    <img *ngIf="media.type === 'csv'" src="assets/images/media/csv.svg" alt="csv" />
                    <img *ngIf="media.type === 'sheet'" src="assets/images/media/excel.svg" alt="xlsx" />
                    <img *ngIf="media.type === 'ppt'" src="assets/images/media/ppt.svg" alt="ppt" />
                    <img *ngIf="media.type === 'pdf'" src="assets/images/media/pdf.svg" alt="pdf" />
                    <div class="circular-player" (click)="togglePlay(media)" *ngIf="media.type === 'audio'">
                      <div class="player" [style.background]="progressStyle">
                        <div class="play-pause">{{ media.isPlaying ? "❚❚" : "►" }}</div>
                      </div>
                    </div>
                    <audio #audioPlayer></audio>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="footer-card-modal">
          <button class="cancel-btn-board" type="button" data-bs-dismiss="modal" (click)="emptyAllFields()">
            {{ "gameLabel.Cancel" | translate }}
          </button>
          <button class="button-add-card" type="button" data-bs-dismiss="modal"
            [disabled]="!(commonService.removeHTMLTags(cardName).trim() && commonService.removeHTMLTags(cardDesc)?.trim())"
            (click)="addCard()">
            {{ "gameLabel.Publish" | translate }}
            <span class="material-symbols-outlined">check_circle</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Add card model end-->


<!-- Edit card model -->
<div class="modal fade" id="editCard" tabindex="-1" aria-labelledby="editCardLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="container-modal-first">
        <header class="header-style-add-board">
          <div class="title-id-content">
            <div class="icon-board-label">
              <span class="material-symbols-outlined">edit_square</span>
            </div>
            <div class="title-desc-board">
              <h4 class="title-add-board" id="editCardLabel">{{ "gameLabel.Edit_Card" | translate }}</h4>
              <p class="description-title-add-board">{{ "gameLabel.Edit_card_subtitle" | translate }}</p>
            </div>
          </div>
          <button class="cancel-icon-board" type="button" data-bs-dismiss="modal" aria-label="Close"
            (click)="cancelEdit()">
            <span class="icon-cancel">
              <span class="material-symbols-outlined">close</span>
            </span>
          </button>
        </header>

        <div class="section-modal-body">
          <div class="select-color-user-data">
            <div class="section-field">
              <div class="section-input-box is-readonly flex-justify-style">
                <div class="label-start-style" *ngIf="boardService.boardType==='assignment'; else editCardBoardName">
                  <span class="section-input-icon" aria-hidden="true">
                    <span class="material-symbols-outlined">assignment</span>
                  </span>
                  <span class="label-flex-style">
                    <label class="section-field-label margin-bottom-style">{{ "gameLabel.Assignment_name" | translate }}</label>
                    <input class="text-color-user-name" type="text" [value]="boardService.assignmentName" readonly />
                  </span>
                </div>
                <ng-template #editCardBoardName>
                  <div class="label-start-style">
                    <span class="section-input-icon" aria-hidden="true">
                      <span class="material-symbols-outlined">credit_card</span>
                    </span>
                    <span class="label-flex-style">
                      <label class="section-field-label margin-bottom-style">{{ "gameLabel.Board_Name" | translate }}</label>
                      <input class="text-color-user-name" type="text" readonly
                        [value]="commonService.removeHTMLTags(boardService.activeBoardName)" />
                    </span>
                  </div>
                </ng-template>

                <div class="label-start-style">
                  <span class="section-input-icon" aria-hidden="true">
                    <span class="material-symbols-outlined">grid_4x4</span>
                  </span>
                  <span class="label-flex-style">
                    <label class="section-field-label margin-bottom-style">{{ "gameLabel.Section_name" | translate }}</label>
                    <input class="text-color-user-name" type="text" [value]="selectedSectionName" readonly />
                  </span>
                </div>
              </div>
            </div>

            <div class="section-field">
              <label class="section-field-label" for="edit-card-name-input">
                {{ "gameLabel.Card_name" | translate }}
                <span class="permanent-color-star">*</span>
              </label>
              <div class="section-input-box">
                <span class="section-input-icon text-icon" aria-hidden="true">T</span>
                <input id="edit-card-name-input" type="text" [(ngModel)]="cardEditTitle"
                  placeholder="Card title" maxlength="60"
                  (click)="setActiveEditor('editTitleCard', 5)" />
              </div>
            </div>

            <div class="section-field">
              <label class="section-field-label">
                {{ "gameLabel.Card_description" | translate }}
                <span class="permanent-color-star">*</span>
              </label>
              <div class="board-description-structure section-desc-editor rl-rich-editor">
                <div class="rl-desc-toolbar" role="toolbar" aria-label="Description formatting">
                  <button type="button" class="rl-desc-btn" title="Bold"
                    (mousedown)="$event.preventDefault()" (click)="applyDescFormat('bold')">
                    <strong>B</strong>
                  </button>
                  <button type="button" class="rl-desc-btn" title="Italic"
                    (mousedown)="$event.preventDefault()" (click)="applyDescFormat('italic')">
                    <em>I</em>
                  </button>
                  <button type="button" class="rl-desc-btn" title="Underline"
                    (mousedown)="$event.preventDefault()" (click)="applyDescFormat('underline')">
                    <span class="rl-desc-u">U</span>
                  </button>
                </div>
                <div class="rl-desc-input"
                  contenteditable="true"
                  role="textbox"
                  aria-multiline="true"
                  [attr.data-placeholder]="'gameLabel.Card_description' | translate"
                  [class.is-empty]="!commonService.removeHTMLTags(cardEditDesc)?.trim()"
                  (input)="onCardEditDescInput($event)"
                  #cardEditDescEditor></div>
              </div>
            </div>
          </div>

          <div class="container-content-data">
            <div class="attachment-data-container">
              <p class="title-attached-text">{{ 'gameLabel.Select_media' | translate }}</p>
              <div class="media-size-limits">
                <span class="media-size-chip">
                  <span class="material-symbols-outlined">image</span>
                  {{ commonService.maxImageSize }}MB
                </span>
                <span class="media-size-chip">
                  <span class="material-symbols-outlined">videocam</span>
                  {{ commonService.maxVideoSize }}MB
                </span>
                <span class="media-size-chip">
                  <span class="material-symbols-outlined">mic</span>
                  {{ commonService.maxAudioSize }}MB
                </span>
                <span class="media-size-chip">
                  <span class="material-symbols-outlined">attach_file</span>
                  {{ commonService.maxFileSize }}MB
                </span>
              </div>
              <div class="icon-container-box">
                <label class="icon-data-upload" for="fileInputImageCardEdit"
                  [class.is-active]="cardMediaTab==='image'"
                  [class.disabled]="boardService.imageCount >= 1"
                  (click)="cardMediaTab='image'">
                  <span class="material-symbols-outlined">image</span>
                </label>
                <input type="file" id="fileInputImageCardEdit" class="file-upload" (change)="onSelectFileInput($event)"
                  style="display: none" accept=".png, .jpeg,.jpg" />

                <label class="icon-data-upload" for="fileInputVideoCardEdit"
                  [class.is-active]="cardMediaTab==='video'"
                  [class.disabled]="boardService.videoCount >= 1"
                  (click)="cardMediaTab='video'">
                  <span class="material-symbols-outlined">video_camera_back</span>
                </label>
                <input type="file" id="fileInputVideoCardEdit" class="file-upload" (change)="onSelectFileInput($event)"
                  style="display: none" accept=".mp4, .avi, .mov" />

                <button class="icon-data-upload" type="button"
                  [class.is-active]="cardMediaTab==='audio'"
                  [class.disabled]="boardService.audioCount === 1"
                  (click)="cardMediaTab='audio'; startRecording()">
                  <span class="material-symbols-outlined">mic</span>
                </button>

                <label class="icon-data-upload" for="fileInputOtherCardEdit"
                  [class.is-active]="cardMediaTab==='file'"
                  [class.disabled]="boardService.fileCount >= 1"
                  (click)="cardMediaTab='file'">
                  <span class="material-symbols-outlined">attachment</span>
                </label>
                <input type="file" id="fileInputOtherCardEdit" class="file-upload" (change)="onSelectFileInput($event)"
                  style="display: none" accept=".pdf,.csv,.xlsx,.ppt,.pptx" />

                <button class="icon-data-upload" type="button"
                  [class.is-active]="cardMediaTab==='search'"
                  [class.disabled]="boardService.imageCount >= 1 && boardService.videoCount >= 1"
                  (click)="cardMediaTab='search'; openModal('webSearch')">
                  <span class="material-symbols-outlined">search</span>
                </button>
              </div>
            </div>

            <div class="media-upload-box"
              [class.is-picker]="uploadedFileArray.length === 0"
              [attr.role]="uploadedFileArray.length === 0 ? 'button' : null"
              [attr.tabindex]="uploadedFileArray.length === 0 ? 0 : null"
              [attr.aria-label]="uploadedFileArray.length === 0 ? ('gameLabel.Choose_or_drop_file' | translate) : null"
              (click)="openCardMediaPicker('edit')"
              (keydown.enter)="openCardMediaPicker('edit')"
              (keydown.space)="$event.preventDefault(); openCardMediaPicker('edit')">
              <ng-container *ngIf="uploadedFileArray.length === 0; else editCardMediaPreviews">
                <div class="media-preview">
                  <span class="material-symbols-outlined">image</span>
                </div>
                <div class="media-upload-text">
                  <p class="media-upload-title">{{ 'gameLabel.No_file_selected' | translate }}</p>
                  <p class="media-upload-hint">{{ 'gameLabel.Choose_or_drop_file' | translate }}</p>
                </div>
                <span class="material-symbols-outlined media-upload-affordance" aria-hidden="true">upload</span>
              </ng-container>
              <ng-template #editCardMediaPreviews>
                <div class="media-previews-row">
                  <div class="media-preview" *ngFor="let media of uploadedFileArray; let i = index">
                    <button class="media-remove-btn" type="button" aria-label="Remove file"
                      (click)="cancelMediaEdit(i, media.type); $event.stopPropagation()">
                      <span class="material-symbols-outlined">close</span>
                    </button>
                    <img *ngIf="media.type === 'image' || media.type === 'webimage'" [src]="media.displayUrl || media.url" alt="" />
                    <video *ngIf="media.type === 'video'" [src]="media.displayUrl || media.url"></video>
                    <iframe *ngIf="media.type === 'webvideo'"
                      [src]="'https://www.youtube.com/embed/' + (media.displayUrl || media.url) | safe" frameborder="0"></iframe>
                    <img *ngIf="media.type === 'csv'" src="assets/images/media/csv.svg" alt="csv" />
                    <img *ngIf="media.type === 'sheet'" src="assets/images/media/excel.svg" alt="xlsx" />
                    <img *ngIf="media.type === 'ppt'" src="assets/images/media/ppt.svg" alt="ppt" />
                    <img *ngIf="media.type === 'pdf'" src="assets/images/media/pdf.svg" alt="pdf" />
                    <div class="circular-player" (click)="togglePlay(media)" *ngIf="media.type === 'audio'">
                      <div class="player" [style.background]="progressStyle">
                        <div class="play-pause">{{ media.isPlaying ? "❚❚" : "►" }}</div>
                      </div>
                    </div>
                    <audio #audioPlayer></audio>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="footer-card-modal">
          <button class="cancel-btn-board" type="button" data-bs-dismiss="modal" (click)="cancelEdit()">
            {{ "gameLabel.Cancel" | translate }}
          </button>
          <button class="button-add-card" type="button"
            [disabled]="!(commonService.removeHTMLTags(cardEditTitle).trim() && commonService.removeHTMLTags(cardEditDesc)?.trim())"
            (click)="updateOldCard(cardView.cardId)">
            {{ "gameLabel.Save" | translate }}
            <span class="material-symbols-outlined">check</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Edit card model end-->


<!-- Edit board model -->
<div class="modal fade" id="editBoard" tabindex="-1" aria-labelledby="editBoardLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="container-add-popup">
        <header class="header-style-add-board">
          <div class="title-id-content">
            <div class="icon-board-label">
              <span class="material-symbols-outlined">edit_square</span>
            </div>
            <div class="title-desc-board">
              <h4 class="title-add-board" id="editBoardLabel">{{ "gameLabel.Edit_Board" | translate }}</h4>
              <p class="description-title-add-board">{{ "gameLabel.Edit_board_subtitle" | translate }}</p>
            </div>
          </div>
          <button class="cancel-icon-board" type="button" data-bs-dismiss="modal" aria-label="Close"
            (click)="emptyAllFields()">
            <span class="icon-cancel">
              <span class="material-symbols-outlined">close</span>
            </span>
          </button>
        </header>

        <div class="content-board-modal">
          <div class="user-board-name-structure">
            <p class="board-name-label">
              {{ "gameLabel.Board_Name" | translate }}
              <span class="permanent-color-star">*</span>
            </p>
            <div class="placeholader-container">
              <div class="icon-palc" aria-hidden="true">Aa</div>
              <input type="text" [(ngModel)]="boardEditTitle"
                [placeholder]="'gameLabel.Board_Name' | translate"
                maxlength="50" />
            </div>
          </div>

          <div class="board-description">
            <p class="board-name-label">
              {{ "gameLabel.board_description" | translate }}
            </p>
            <div class="board-description-structure rl-rich-editor">
              <div class="rl-desc-toolbar" role="toolbar" aria-label="Description formatting">
                <button type="button" class="rl-desc-btn" title="Bold"
                  (mousedown)="$event.preventDefault()" (click)="applyDescFormat('bold')">
                  <strong>B</strong>
                </button>
                <button type="button" class="rl-desc-btn" title="Italic"
                  (mousedown)="$event.preventDefault()" (click)="applyDescFormat('italic')">
                  <em>I</em>
                </button>
                <button type="button" class="rl-desc-btn" title="Underline"
                  (mousedown)="$event.preventDefault()" (click)="applyDescFormat('underline')">
                  <span class="rl-desc-u">U</span>
                </button>
              </div>
              <div class="rl-desc-input"
                contenteditable="true"
                role="textbox"
                aria-multiline="true"
                [attr.data-placeholder]="'gameLabel.board_description' | translate"
                [class.is-empty]="!commonService.removeHTMLTags(boardEditDesc)?.trim()"
                (input)="onBoardEditDescInput($event)"
                #boardEditDescEditor></div>
            </div>
          </div>
        </div>

        <div class="footer-add-board-container">
          <button class="cancel-btn-board" type="button" data-bs-dismiss="modal" (click)="emptyAllFields()">
            {{ "gameLabel.Cancel" | translate }}
          </button>
          <button class="add-btn-board" type="button" data-bs-dismiss="modal"
            [disabled]="!commonService.removeHTMLTags(boardEditTitle)?.trim()"
            (click)="editBoardSave()">
            {{ "gameLabel.Save" | translate }}
            <span class="material-symbols-outlined">check</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Edit board model end -->

<!-- Expand section -->
<div class="modal fade" id="expandSection" tabindex="-1" aria-labelledby="expandSectionTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered expand-section-dialog">
    <div class="modal-content expand-section-content"
      *ngIf="expandedSection"
      [class.is-viewing-card]="expandSectionCardOpen"
      [style.--section-color]="getSectionColor(expandedSection)">
      <button type="button" class="expand-section-close" data-bs-dismiss="modal" aria-label="Close"
        (click)="closeExpandSection()">
        <span class="material-symbols-outlined">close</span>
      </button>

      <aside class="expand-section-aside">
        <div class="expand-section-icon" aria-hidden="true">
          <span class="material-symbols-outlined">view_column</span>
        </div>
        <h3 class="expand-section-title" id="expandSectionTitle"
          [innerHTML]="commonService.getSanitizeHtml(expandedSection.sectionName)"></h3>
        <p class="expand-section-desc"
          [class.is-empty]="!getSectionDescText(expandedSection)">
          {{ getSectionDescText(expandedSection) || ('gameLabel.No_description' | translate) }}
        </p>

        <div class="expand-section-meta">
          <span class="avatar sm">{{ getInitials(expandedSection.user_info?.name) }}</span>
          <div class="expand-section-meta-text">
            <span class="expand-section-owner">{{ expandedSection.user_info?.name }}</span>
            <span class="expand-section-role">{{ 'gameLabel.Owner' | translate }}</span>
          </div>
        </div>

        <div class="expand-section-count">
          <span class="material-symbols-outlined" aria-hidden="true">layers</span>
          {{ expandedSection.cards?.length || 0 }} {{ 'gameLabel.Cards' | translate }}
        </div>

        <button class="expand-section-add" type="button"
          *ngIf="boardService.cardCreateEdit"
          data-bs-toggle="modal" data-bs-target="#addCard">
          + {{ 'gameLabel.Add_Card' | translate }}
        </button>

        <div class="expand-section-media" *ngIf="expandedSection.media?.length > 0">
          <ng-container *ngFor="let media of expandedSection.media">
            <img *ngIf="media.type==='image' || media.type==='webimage'"
              (click)="setDefaultMedia(expandedSection.media, media.name, expandedSection.user_info?.name)" [src]="media.url" alt="">
            <video *ngIf="media.type==='video'" [src]="media.url"
              (click)="setDefaultMedia(expandedSection.media, media.name, expandedSection.user_info?.name)"></video>
            <img *ngIf="media.type==='webvideo'"
              (click)="setDefaultMedia(expandedSection.media, media.name, expandedSection.user_info?.name)"
              [src]="'https://img.youtube.com/vi/' + media.url + '/hqdefault.jpg'" alt="">
            <img class="is-file" *ngIf="media.type === 'csv'" src="assets/images/media/csv.svg"
              (click)="setDefaultMedia(expandedSection.media, media.name, expandedSection.user_info?.name)" alt="csv">
            <img class="is-file" *ngIf="media.type === 'sheet'" src="assets/images/media/excel.svg"
              (click)="setDefaultMedia(expandedSection.media, media.name, expandedSection.user_info?.name)" alt="xlsx">
            <img class="is-file" *ngIf="media.type === 'ppt'" src="assets/images/media/ppt.svg"
              (click)="setDefaultMedia(expandedSection.media, media.name, expandedSection.user_info?.name)" alt="ppt">
            <img class="is-file" *ngIf="media.type === 'pdf'" src="assets/images/media/pdf.svg"
              (click)="setDefaultMedia(expandedSection.media, media.name, expandedSection.user_info?.name)" alt="pdf">
            <button type="button" class="card-audio-tile" *ngIf="media.type === 'audio'"
              (click)="setDefaultMedia(expandedSection.media, media.name, expandedSection.user_info?.name)">
              <span class="card-audio-icon" aria-hidden="true">
                <span class="material-symbols-outlined">graphic_eq</span>
              </span>
              <span class="card-audio-copy">
                <span class="card-audio-label">{{ 'gameLabel.Audio' | translate }}</span>
                <span class="card-audio-from">{{ 'gameLabel.Audio_from' | translate: { name: expandedSection.user_info?.name } }}</span>
              </span>
              <span class="card-audio-play" aria-hidden="true">
                <span class="material-symbols-outlined">play_arrow</span>
              </span>
            </button>
          </ng-container>
        </div>
      </aside>

      <div class="expand-section-main">
        <div class="expand-section-cards" *ngIf="expandedSection.cards?.length; else expandEmptyCards">
          <article class="expand-card" *ngFor="let card of expandedSection.cards"
            [class.is-clickable]="boardService.cardView"
            (click)="onCardSurfaceClick($event, card, expandedSection.sectionName)">
            <div class="expand-card-top">
              <div class="expand-card-user">
                <span class="avatar sm">{{ getInitials(card.user_info?.name) }}</span>
                <span class="expand-card-name">{{ card.user_info?.name }}</span>
                <span class="expand-card-time">{{ commonService.calculateHours(card.cardCreatedDate) }}</span>
              </div>
              <div ngbDropdown (click)="$event.stopPropagation()">
                <button class="icon-btn sm" type="button" ngbDropdownToggle aria-label="More">
                  <span class="material-symbols-outlined">more_vert</span>
                </button>
                <div class="dropdown-menu-end header-dropdown header-dropdown-sm card-menu" ngbDropdownMenu>
                  <div class="header-dropdown-body header-menu-list">
                    <a class="header-menu-item" ngbDropdownItem *ngIf="boardService.cardView"
                      (click)="viewCard(card, expandedSection.sectionName)">
                      <span class="material-symbols-outlined">visibility</span>
                      <span>{{'gameLabel.View'|translate}}</span>
                    </a>
                    <a class="header-menu-item" ngbDropdownItem
                      *ngIf="boardService.cardCreateEdit && card.user_info.id===commonService.user.id"
                      (click)="editCardDir(card, expandedSection.sectionName)">
                      <span class="material-symbols-outlined">edit</span>
                      <span>{{'gameLabel.Edit'|translate}}</span>
                    </a>
                    <a class="header-menu-item is-danger" ngbDropdownItem
                      *ngIf="boardService.cardCreateEdit && card.user_info.id===commonService.user.id && card.cardComment.length===0 && card.reactions.length===0"
                      (click)="deleteCardConfirm(card.cardId, expandedSection.sectionId)">
                      <span class="material-symbols-outlined">delete</span>
                      <span>{{'gameLabel.Delete'|translate}}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="expand-card-media-wrap" *ngIf="getCardPreview(card) as preview"
              (click)="viewCard(card, expandedSection.sectionName)">
              <img class="expand-card-media" *ngIf="preview.kind === 'image'" [src]="preview.url" alt="">
              <video class="expand-card-media" *ngIf="preview.kind === 'video'" [src]="preview.url"></video>
              <img class="expand-card-media is-file" *ngIf="preview.kind === 'file'" [src]="preview.url" alt="">
            </div>

            <h4 class="expand-card-title" (click)="viewCard(card, expandedSection.sectionName)"
              [innerHTML]="commonService.getSanitizeHtml(card.cardTitle)"></h4>
            <p class="expand-card-desc" (click)="viewCard(card, expandedSection.sectionName)">
              <span>{{ getCardDescText(card) | truncate: 220 }}</span>
            </p>

            <div class="expand-card-footer">
              <span>{{ 'gameLabel.Comment' | translate }}: {{ card.cardComment?.length || 0 }}</span>
              <button type="button" class="expand-card-open"
                (click)="viewCard(card, expandedSection.sectionName)">
                {{ 'gameLabel.View' | translate }}
                <span class="material-symbols-outlined">arrow_forward</span>
              </button>
            </div>
          </article>
        </div>
        <ng-template #expandEmptyCards>
          <div class="expand-section-empty">
            <span class="material-symbols-outlined" aria-hidden="true">note_stack</span>
            <p>{{ 'gameLabel.No_cards_in_section' | translate }}</p>
          </div>
        </ng-template>
      </div>

      <div class="expand-section-card-detail" *ngIf="expandSectionCardOpen">
        <header class="expand-card-detail-header">
          <button type="button" class="expand-card-detail-back" (click)="closeExpandSectionCard()">
            <span class="material-symbols-outlined">arrow_back</span>
            {{ 'gameLabel.Back' | translate }}
          </button>
          <div class="expand-card-detail-heading">
            <h3>{{ getCardAuthorName(cardView) }}</h3>
            <span *ngIf="cardView.cardCreatedDate">{{ cardView.cardCreatedDate | date }}</span>
          </div>
          <div class="expand-card-detail-actions"
            *ngIf="boardService.cardCreateEdit && viewCardUserId===commonService.user.id">
            <button class="icon-btn" type="button" (click)="editCard()"
              [attr.aria-label]="'gameLabel.Edit' | translate">
              <span class="material-symbols-outlined">edit</span>
            </button>
          </div>
        </header>

        <div class="expand-card-detail-body">
          <h3 class="expand-card-detail-title"
            [innerHTML]="commonService.getSanitizeHtml(cardView.cardTitle)"></h3>
          <div class="expand-card-detail-desc"
            [class.is-empty]="!commonService.removeHTMLTags(cardView.cardDesc)?.trim()"
            [innerHTML]="sanitizer.bypassSecurityTrustHtml(cardView.cardDesc)"></div>

          <div class="expand-card-detail-media"
            *ngIf="cardView.thumbnail?.length || cardView.media?.length || cardView.sdg_tags?.length">
            <div class="expand-card-detail-media-row" *ngIf="cardView.thumbnail?.length">
              <button class="expand-card-detail-preview is-wide" type="button"
                (click)="clickThumbnail(cardView.thumbnail[0].url)">
                <img [src]="cardView.thumbnail[0].url" alt="">
              </button>
            </div>

            <div class="expand-card-detail-media-row" *ngIf="cardView.media?.length">
              <div class="expand-card-detail-preview" *ngFor="let media of cardView.media">
                <img *ngIf="media.type === 'image' || media.type === 'webimage'"
                  (click)="setDefaultMedia(cardView.media, media.name, getCardAuthorName(cardView))" [src]="media.url" alt="">
                <video *ngIf="media.type === 'video'" [src]="media.url"
                  (click)="setDefaultMedia(cardView.media, media.name, getCardAuthorName(cardView))"></video>
                <iframe *ngIf="media.type === 'webvideo'"
                  [src]="'https://www.youtube.com/embed/' + media.url | safe" frameborder="0"></iframe>
                <img *ngIf="media.type === 'csv'" src="assets/images/media/csv.svg"
                  (click)="setDefaultMedia(cardView.media, media.name, getCardAuthorName(cardView))" alt="csv">
                <img *ngIf="media.type === 'sheet'" src="assets/images/media/excel.svg"
                  (click)="setDefaultMedia(cardView.media, media.name, getCardAuthorName(cardView))" alt="xlsx">
                <img *ngIf="media.type === 'ppt'" src="assets/images/media/ppt.svg"
                  (click)="setDefaultMedia(cardView.media, media.name, getCardAuthorName(cardView))" alt="ppt">
                <img *ngIf="media.type === 'pdf'" src="assets/images/media/pdf.svg"
                  (click)="setDefaultMedia(cardView.media, media.name, getCardAuthorName(cardView))" alt="pdf">
                <button type="button" class="card-audio-tile" *ngIf="media.type === 'audio'"
                  (click)="setDefaultMedia(cardView.media, media.name, getCardAuthorName(cardView))">
                  <span class="card-audio-icon" aria-hidden="true">
                    <span class="material-symbols-outlined">graphic_eq</span>
                  </span>
                  <span class="card-audio-copy">
                    <span class="card-audio-label">{{ 'gameLabel.Audio' | translate }}</span>
                    <span class="card-audio-from">{{ 'gameLabel.Audio_from' | translate: { name: getCardAuthorName(cardView) } }}</span>
                  </span>
                  <span class="card-audio-play" aria-hidden="true">
                    <span class="material-symbols-outlined">play_arrow</span>
                  </span>
                </button>
              </div>
            </div>

            <div class="expand-card-detail-sdg" *ngIf="cardView.sdg_tags?.length">
              <button type="button" class="expand-card-detail-sdg-item" *ngFor="let sdg of cardView.sdg_tags"
                (click)="sdgView(cardView.sdg_tags)">
                <img src="assets/images/sdgicon/sdg{{sdg}}_{{commonService.selectedlang}}.png" alt="">
              </button>
            </div>
          </div>

          <div class="expand-card-detail-reactions">
            <div class="emotion-icon-container" *ngIf="cardView.showReactionEdit">
              <div class="icon-box mojiFont text-center">
                <span [class.selected]="selectedReaction === 'like'" (click)="setReaction('like',cardView)">👍</span>
              </div>
              <div class="icon-box mojiFont text-center">
                <span [class.selected]="selectedReaction === 'love'" (click)="setReaction('love',cardView)">❤️</span>
              </div>
              <div class="icon-box mojiFont text-center">
                <span [class.selected]="selectedReaction === 'haha'" (click)="setReaction('haha',cardView)">😂</span>
              </div>
              <div class="icon-box mojiFont text-center">
                <span [class.selected]="selectedReaction === 'wow'" (click)="setReaction('wow',cardView)">😮</span>
              </div>
              <div class="icon-box mojiFont text-center">
                <span [class.selected]="selectedReaction === 'sad'" (click)="setReaction('sad',cardView)">😢</span>
              </div>
              <div class="icon-box mojiFont text-center">
                <span [class.selected]="selectedReaction === 'angry'" (click)="setReaction('angry',cardView)">😡</span>
              </div>
            </div>
            <div class="emotions-icon-containetr-popup">
              <div class="icon-box-popup overlap-margin pointer" *ngFor="let reaction of cardView.lastThreeReaction"
                data-bs-toggle="modal" data-bs-target="#reactionModel"
                (click)="reactionModel(cardView.reactions,cardView)">
                <span class="emogiFontDisplay" *ngIf="reaction.type==='like'">👍</span>
                <span class="emogiFontDisplay" *ngIf="reaction.type==='love'">❤️</span>
                <span class="emogiFontDisplay" *ngIf="reaction.type==='haha'">😂</span>
                <span class="emogiFontDisplay" *ngIf="reaction.type==='wow'">😮</span>
                <span class="emogiFontDisplay" *ngIf="reaction.type==='sad'">😢</span>
                <span class="emogiFontDisplay" *ngIf="reaction.type==='angry'">😡</span>
              </div>
              <div class="icon-box-popup overlap-right-plus pointer" *ngIf="cardView.reactionCount>3"
                data-bs-toggle="modal" data-bs-target="#reactionModel"
                (click)="reactionModel(cardView.reactions,cardView)">
                <p>+{{cardView.reactionCount}}</p>
              </div>
              <button class="expand-card-detail-react {{cardView.reactionIconClass}}" type="button"
                (click)="clickReactionEdit(cardView)">
                <span class="material-symbols-outlined">sentiment_satisfied</span>
              </button>
            </div>
            <div class="expand-card-detail-rating" *ngIf="boardService.assignmentId>0">
              <ngb-rating [max]=5 [(rate)]="cardView.cardRating" [readonly]="true"
                *ngIf="!boardService.cardRating"></ngb-rating>
              <ngb-rating [max]=5 [(rate)]="cardView.cardRating" (rateChange)="getValue(cardView,cardView.cardRating)"
                *ngIf="boardService.cardRating"></ngb-rating>
            </div>
          </div>

          <section class="view-card-comments rl-thread">
            <div class="view-card-comments-head">
              <h5>{{ 'gameLabel.Comment' | translate }}</h5>
              <span class="view-card-comments-count">{{ cardView.cardComment.length }}</span>
            </div>

            <div class="view-card-comment-list" *ngIf="cardView.cardComment.length; else expandCardNoComments">
              <article class="view-card-comment" *ngFor="let comment of cardView.cardComment">
                <span class="avatar sm">{{ getInitials(comment.name) }}</span>
                <div class="view-card-comment-body">
                  <div class="view-card-comment-meta">
                    <strong>{{ comment.name }}</strong>
                    <time>{{ commonService.calculateHours(comment.id) }}</time>
                    <div class="view-card-comment-actions"
                      *ngIf="comment.user_id===commonService.userId && !comment.editCommentFlag">
                      <button type="button" (click)="editClick(comment)"
                        [attr.aria-label]="'gameLabel.Edit' | translate">
                        <span class="material-symbols-outlined">edit</span>
                      </button>
                      <button type="button" class="is-danger"
                        (click)="deleteCommentConfirm(cardView.cardId,comment.id,cardView.sectionId)"
                        [attr.aria-label]="'gameLabel.Delete' | translate">
                        <span class="material-symbols-outlined">delete</span>
                      </button>
                    </div>
                  </div>
                  <p class="view-card-comment-text" *ngIf="!comment.editCommentFlag">{{ comment.text }}</p>
                  <div class="view-card-comment-editor"
                    *ngIf="comment.editCommentFlag && editCommentId===comment.id">
                    <input type="text" [(ngModel)]="editCommentText"
                      [placeholder]="'gameLabel.Add_comment' | translate"
                      (keyup.enter)="editComment(cardView.cardId,cardView.sectionId)">
                    <button type="button" (click)="cancelEditComment(comment)" aria-label="Cancel">
                      <span class="material-symbols-outlined">close</span>
                    </button>
                    <button type="button" class="is-save"
                      (click)="editComment(cardView.cardId,cardView.sectionId)"
                      [disabled]="comment.text===editCommentText || editCommentText===''">
                      <span class="material-symbols-outlined">check</span>
                    </button>
                  </div>
                </div>
              </article>
            </div>
            <ng-template #expandCardNoComments>
              <p class="view-card-comments-empty">{{ 'gameLabel.No_comments' | translate }}</p>
            </ng-template>
          </section>
        </div>

        <div class="expand-card-detail-composer">
          <span class="avatar sm">{{ getInitials(commonService.user?.name) }}</span>
          <label class="expand-card-detail-composer-box">
            <input type="text" [(ngModel)]="cardView.commentText"
              [placeholder]="'gameLabel.Add_comment' | translate"
              (keyup.enter)="saveComment(cardView.commentText,cardView.cardId,cardView.cardComment.length,cardView.sectionId)">
            <button type="button" [disabled]="!cardView.commentText"
              (click)="saveComment(cardView.commentText,cardView.cardId,cardView.cardComment.length,cardView.sectionId)">
              <span class="material-symbols-outlined">send</span>
            </button>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Expand section end -->

<!-- view / edit section modal -->
<div class="modal fade" id="viewSection" tabindex="-1" aria-labelledby="viewSectionLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="container-section-main">
        <header class="header-style-add-board">
          <div class="title-id-content">
            <div class="icon-board-label">
              <span class="material-symbols-outlined">{{ sectionEditFlag ? 'edit_square' : 'dashboard' }}</span>
            </div>
            <div class="title-desc-board">
              <ng-container *ngIf="sectionEditFlag; else viewSectionHeader">
                <h4 class="title-add-board" id="viewSectionLabel">{{ 'gameLabel.Edit_Section' | translate }}</h4>
                <p class="description-title-add-board">{{ 'gameLabel.Edit_section_subtitle' | translate }}</p>
              </ng-container>
              <ng-template #viewSectionHeader>
                <h4 class="title-add-board" id="viewSectionLabel">
                  {{ sectionView?.user_info?.name || ('gameLabel.View_Section' | translate) }}
                  <span *ngIf="sectionView?.created_date"> · {{ sectionView.created_date | date }}</span>
                </h4>
                <p class="description-title-add-board"
                  [innerHTML]="commonService.getSanitizeHtml(commonService.removeHTMLTags(sectionView?.sectionName))"></p>
              </ng-template>
            </div>
          </div>
          <div class="view-card-header-actions">
            <button class="cancel-icon-board" type="button" (click)="editSection()"
              *ngIf="!sectionEditFlag && boardService.sectionCreateEdit"
              [attr.aria-label]="'gameLabel.Edit' | translate">
              <span class="icon-cancel">
                <span class="material-symbols-outlined">edit</span>
              </span>
            </button>
            <button class="cancel-icon-board" type="button"
              (click)="deleteSectionConfirm(sectionView.sectionId)"
              *ngIf="!sectionEditFlag && boardService.sectionCreateEdit && sectionView?.cards?.length===0"
              [attr.aria-label]="'gameLabel.Delete' | translate">
              <span class="icon-cancel">
                <span class="material-symbols-outlined">delete</span>
              </span>
            </button>
            <button class="cancel-icon-board" type="button" data-bs-dismiss="modal" aria-label="Close"
              (click)="cancelSectionEdit(true)">
              <span class="icon-cancel">
                <span class="material-symbols-outlined">close</span>
              </span>
            </button>
          </div>
        </header>

        <!-- View mode -->
        <div class="section-modal-body" *ngIf="!sectionEditFlag">
          <div class="select-color-user-data">
            <div class="section-field">
              <label class="section-field-label">{{ 'gameLabel.Board_Name' | translate }}</label>
              <div class="section-input-box is-readonly">
                <span class="section-input-icon" aria-hidden="true">
                  <span class="material-symbols-outlined">dashboard</span>
                </span>
                <input type="text" readonly
                  [value]="commonService.removeHTMLTags(boardService.activeBoardName)" />
              </div>
            </div>

            <div class="section-field">
              <label class="section-field-label">{{ 'gameLabel.Section_name' | translate }}</label>
              <div class="section-input-box is-readonly">
                <span class="section-input-icon text-icon" aria-hidden="true">T</span>
                <input type="text" readonly
                  [value]="commonService.removeHTMLTags(sectionView?.sectionName)" />
              </div>
            </div>

            <div class="section-field" *ngIf="sectionView?.sectionDesc">
              <label class="section-field-label">{{ 'gameLabel.Section_description' | translate }}</label>
              <div class="board-description-structure section-desc-editor section-desc-readonly">
                <div class="rl-desc-input is-readonly"
                  [innerHTML]="sanitizer.bypassSecurityTrustHtml(sectionView.sectionDesc)"></div>
              </div>
            </div>
          </div>

          <div class="document-data-container" *ngIf="sectionView?.media?.length">
            <div class="media-attach-heading">
              <h5>{{ 'gameLabel.Selected_media' | translate }}</h5>
            </div>
            <div class="media-upload-box">
              <div class="media-previews-row">
                <div class="media-preview" *ngFor="let media of sectionView.media">
                  <img *ngIf="media.type === 'image' || media.type === 'webimage'" [src]="media.url" alt="" />
                  <video *ngIf="media.type === 'video'" [src]="media.url" controls></video>
                  <iframe *ngIf="media.type === 'webvideo'"
                    [src]="'https://www.youtube.com/embed/' + media.url | safe" frameborder="0" allowfullscreen></iframe>
                  <img *ngIf="media.type === 'csv'" src="assets/images/media/csv.svg" alt="csv" />
                  <img *ngIf="media.type === 'sheet'" src="assets/images/media/excel.svg" alt="xlsx" />
                  <img *ngIf="media.type === 'ppt'" src="assets/images/media/ppt.svg" alt="ppt" />
                  <img *ngIf="media.type === 'pdf'" src="assets/images/media/pdf.svg" alt="pdf" />
                  <div class="circular-player" (click)="togglePlay(media)" *ngIf="media.type === 'audio'">
                    <div class="player" [style.background]="progressStyle">
                      <div class="play-pause">{{ media.isPlaying ? '❚❚' : '►' }}</div>
                    </div>
                  </div>
                  <audio #audioPlayer></audio>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Edit mode -->
        <div class="section-modal-body" *ngIf="sectionEditFlag">
          <div class="select-color-user-data">
            <p class="section-field-label">{{ 'gameLabel.Select_section_color' | translate }}</p>
            <div class="section-color-row" role="listbox" aria-label="Section color">
              <button class="color-swatch" type="button" *ngFor="let swatch of sectionColorSwatches"
                [style.--swatch]="swatch"
                [class.is-selected]="colourPickerService.selctedColor === swatch"
                [attr.aria-pressed]="colourPickerService.selctedColor === swatch"
                (click)="selectSectionColor(swatch)">
                <span class="material-symbols-outlined">check</span>
              </button>
            </div>

            <div class="section-field">
              <label class="section-field-label">{{ 'gameLabel.Board_Name' | translate }}</label>
              <div class="section-input-box is-readonly">
                <span class="section-input-icon" aria-hidden="true">
                  <span class="material-symbols-outlined">dashboard</span>
                </span>
                <input type="text" readonly
                  [value]="commonService.removeHTMLTags(boardService.activeBoardName)" />
              </div>
            </div>

            <div class="section-field">
              <label class="section-field-label" for="section-edit-name-input">
                {{ 'gameLabel.Section_name' | translate }}
                <span class="permanent-color-star">*</span>
              </label>
              <div class="section-input-box">
                <span class="section-input-icon text-icon" aria-hidden="true">T</span>
                <input id="section-edit-name-input" type="text"
                  [(ngModel)]="sectionEditTitle"
                  placeholder="Section title"
                  maxlength="60" />
              </div>
            </div>

            <div class="section-field">
              <label class="section-field-label">
                {{ 'gameLabel.Section_description' | translate }}
                <span class="permanent-color-star">*</span>
              </label>
              <div class="board-description-structure section-desc-editor rl-rich-editor">
                <div class="rl-desc-toolbar" role="toolbar" aria-label="Description formatting">
                  <button type="button" class="rl-desc-btn" title="Bold"
                    (mousedown)="$event.preventDefault()" (click)="applyDescFormat('bold')">
                    <strong>B</strong>
                  </button>
                  <button type="button" class="rl-desc-btn" title="Italic"
                    (mousedown)="$event.preventDefault()" (click)="applyDescFormat('italic')">
                    <em>I</em>
                  </button>
                  <button type="button" class="rl-desc-btn" title="Underline"
                    (mousedown)="$event.preventDefault()" (click)="applyDescFormat('underline')">
                    <span class="rl-desc-u">U</span>
                  </button>
                </div>
                <div class="rl-desc-input"
                  contenteditable="true"
                  role="textbox"
                  aria-multiline="true"
                  [attr.data-placeholder]="'gameLabel.Section_description' | translate"
                  [class.is-empty]="!commonService.removeHTMLTags(editSectionDesc)?.trim()"
                  (input)="onSectionEditDescInput($event)"
                  #sectionEditDescEditor></div>
              </div>
            </div>
          </div>

          <div class="document-data-container">
            <div class="media-attach-heading">
              <h5>{{ 'gameLabel.Select_media' | translate }}</h5>
              <div class="media-size-limits">
                <span class="media-size-chip">
                  <span class="material-symbols-outlined">image</span>
                  {{ commonService.maxImageSize }}MB
                </span>
                <span class="media-size-chip">
                  <span class="material-symbols-outlined">videocam</span>
                  {{ commonService.maxVideoSize }}MB
                </span>
                <span class="media-size-chip">
                  <span class="material-symbols-outlined">mic</span>
                  {{ commonService.maxAudioSize }}MB
                </span>
                <span class="media-size-chip">
                  <span class="material-symbols-outlined">attach_file</span>
                  {{ commonService.maxFileSize }}MB
                </span>
              </div>
            </div>

            <div class="media-tabs" role="tablist" aria-label="Media type">
              <label class="media-tab" for="fileInputImageSectionEdit"
                [class.is-active]="sectionMediaTab==='image'"
                [class.disabled]="boardService.imageCount >= 1"
                (click)="sectionMediaTab='image'">
                <span class="material-symbols-outlined">image</span>
              </label>
              <input type="file" id="fileInputImageSectionEdit" class="file-upload" (change)="onSelectFileInput($event)"
                style="display: none" accept=".png, .jpeg,.jpg" />

              <label class="media-tab" for="fileInputVideoSectionEdit"
                [class.is-active]="sectionMediaTab==='video'"
                [class.disabled]="boardService.videoCount >= 1"
                (click)="sectionMediaTab='video'">
                <span class="material-symbols-outlined">videocam</span>
              </label>
              <input type="file" id="fileInputVideoSectionEdit" class="file-upload" (change)="onSelectFileInput($event)"
                style="display: none" accept=".mp4, .avi, .mov" />

              <button class="media-tab" type="button"
                [class.is-active]="sectionMediaTab==='audio'"
                [class.disabled]="boardService.audioCount >= 1"
                (click)="sectionMediaTab='audio'; startRecording()">
                <span class="material-symbols-outlined">mic</span>
              </button>

              <label class="media-tab" for="fileInputOtherSectionEdit"
                [class.is-active]="sectionMediaTab==='file'"
                [class.disabled]="boardService.fileCount >= 1"
                (click)="sectionMediaTab='file'">
                <span class="material-symbols-outlined">attach_file</span>
              </label>
              <input type="file" id="fileInputOtherSectionEdit" class="file-upload" (change)="onSelectFileInput($event)"
                style="display: none" accept=".pdf,.csv,.xlsx,.ppt,.pptx" />

              <button class="media-tab" type="button"
                [class.is-active]="sectionMediaTab==='search'"
                [class.disabled]="boardService.imageCount >= 1 && boardService.videoCount >= 1"
                (click)="sectionMediaTab='search'; openModal('webSearch')">
                <span class="material-symbols-outlined">search</span>
              </button>
            </div>

            <div class="media-upload-box">
              <ng-container *ngIf="uploadedFileArray.length === 0; else sectionEditMediaPreviews">
                <div class="media-preview">
                  <span class="material-symbols-outlined">image</span>
                </div>
                <div class="media-upload-text">
                  <p class="media-upload-title">{{ 'gameLabel.No_file_selected' | translate }}</p>
                  <p class="media-upload-hint">{{ 'gameLabel.Choose_or_drop_file' | translate }}</p>
                </div>
              </ng-container>
              <ng-template #sectionEditMediaPreviews>
                <div class="media-previews-row">
                  <div class="media-preview" *ngFor="let media of uploadedFileArray; let i = index">
                    <button class="media-remove-btn" type="button" aria-label="Remove file"
                      (click)="cancelMediaEdit(i, media.type)">
                      <span class="material-symbols-outlined">close</span>
                    </button>
                    <img *ngIf="(media.type === 'image' || media.type === 'webimage') && !media.edit" [src]="media.url" alt="" />
                    <img *ngIf="(media.type === 'image' || media.type === 'webimage') && media.edit" [src]="media.displayUrl" alt="" />
                    <video *ngIf="media.type === 'video' && !media.edit" [src]="media.url"></video>
                    <video *ngIf="media.type === 'video' && media.edit" [src]="media.displayUrl"></video>
                    <iframe *ngIf="media.type === 'webvideo' && !media.edit"
                      [src]="'https://www.youtube.com/embed/' + media.url | safe" frameborder="0"></iframe>
                    <iframe *ngIf="media.type === 'webvideo' && media.edit"
                      [src]="'https://www.youtube.com/embed/' + media.displayUrl | safe" frameborder="0"></iframe>
                    <img *ngIf="media.type === 'csv'" src="assets/images/media/csv.svg" alt="csv" />
                    <img *ngIf="media.type === 'sheet'" src="assets/images/media/excel.svg" alt="xlsx" />
                    <img *ngIf="media.type === 'ppt'" src="assets/images/media/ppt.svg" alt="ppt" />
                    <img *ngIf="media.type === 'pdf'" src="assets/images/media/pdf.svg" alt="pdf" />
                    <div class="circular-player" (click)="togglePlay(media)" *ngIf="media.type === 'audio'">
                      <div class="player" [style.background]="progressStyle">
                        <div class="play-pause">{{ media.isPlaying ? '❚❚' : '►' }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="footer-section-modal" *ngIf="sectionEditFlag">
          <button class="cancel-btn-board" type="button" (click)="cancelSectionEdit(false)">
            {{ 'gameLabel.Cancel' | translate }}
          </button>
          <button class="publish-section-btn" type="button"
            [disabled]="!(commonService.removeHTMLTags(sectionEditTitle).trim() && commonService.removeHTMLTags(editSectionDesc)?.trim())"
            (click)="updateOldSection(sectionView.sectionId)">
            {{ 'gameLabel.Save' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- view / edit section modal end -->


<!-- view-card-model -->
<div class="modal fade" id="viewCard" tabindex="-1" aria-labelledby="viewCardLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="container-modal-first">
        <header class="header-style-add-board">
          <div class="title-id-content">
            <div class="title-desc-board">
              <h4 class="title-add-board" id="viewCardLabel">
                {{ getCardAuthorName(cardView) }}
                <span *ngIf="cardView.cardCreatedDate"> · {{ cardView.cardCreatedDate | date }}</span>
              </h4>
            </div>
          </div>
          <div class="view-card-header-actions">
            <button class="cancel-icon-board" type="button" (click)="editCard()"
              *ngIf="boardService.cardCreateEdit && viewCardUserId===commonService.user.id"
              [attr.aria-label]="'gameLabel.Edit' | translate">
              <span class="icon-cancel">
                <span class="material-symbols-outlined">edit</span>
              </span>
            </button>
            <button class="cancel-icon-board" type="button"
              (click)="deleteCardConfirm(cardView.cardId,cardView.sectionId)"
              *ngIf="boardService.cardCreateEdit && viewCardUserId===commonService.user.id && cardView.cardComment.length===0 && cardView.reactions.length===0"
              [attr.aria-label]="'gameLabel.Delete' | translate">
              <span class="icon-cancel">
                <span class="material-symbols-outlined">delete</span>
              </span>
            </button>
            <button class="cancel-icon-board" type="button" data-bs-dismiss="modal" aria-label="Close">
              <span class="icon-cancel">
                <span class="material-symbols-outlined">close</span>
              </span>
            </button>
          </div>
        </header>

        <div class="section-modal-body">
          <div class="select-color-user-data">
            <div class="section-field">
              <div class="section-input-box is-readonly flex-justify-style">
                <div class="label-start-style" *ngIf="boardService.boardType==='assignment'; else viewCardBoardName">
                  <span class="section-input-icon" aria-hidden="true">
                    <span class="material-symbols-outlined">assignment</span>
                  </span>
                  <span class="label-flex-style">
                    <label class="section-field-label margin-bottom-style">{{ "gameLabel.Assignment_name" | translate }}</label>
                    <input class="text-color-user-name" type="text" [value]="boardService.assignmentName" readonly />
                  </span>
                </div>
                <ng-template #viewCardBoardName>
                  <div class="label-start-style">
                    <span class="section-input-icon" aria-hidden="true">
                      <span class="material-symbols-outlined">credit_card</span>
                    </span>
                    <span class="label-flex-style">
                      <label class="section-field-label margin-bottom-style">{{ "gameLabel.Board_Name" | translate }}</label>
                      <input class="text-color-user-name" type="text" readonly
                        [value]="commonService.removeHTMLTags(boardService.activeBoardName)" />
                    </span>
                  </div>
                </ng-template>

                <div class="label-start-style">
                  <span class="section-input-icon" aria-hidden="true">
                    <span class="material-symbols-outlined">grid_4x4</span>
                  </span>
                  <span class="label-flex-style">
                    <label class="section-field-label margin-bottom-style">{{ "gameLabel.Section_name" | translate }}</label>
                    <input class="text-color-user-name" type="text"
                      [value]="commonService.removeHTMLTags(boardService.viewCardSectionName)" readonly />
                  </span>
                </div>
              </div>
            </div>

            <div class="view-card-copy">
              <h3 class="view-card-title"
                [innerHTML]="commonService.getSanitizeHtml(cardView.cardTitle)"></h3>
              <div class="view-card-desc"
                [class.is-empty]="!commonService.removeHTMLTags(cardView.cardDesc)?.trim()"
                [innerHTML]="sanitizer.bypassSecurityTrustHtml(cardView.cardDesc)"></div>
            </div>
          </div>

          <div class="view-card-media" *ngIf="cardView.thumbnail?.length || cardView.media?.length || cardView.sdg_tags?.length">
            <div class="media-previews-row" *ngIf="cardView.thumbnail?.length">
              <button class="media-preview is-wide" type="button"
                (click)="clickThumbnail(cardView.thumbnail[0].url)">
                <img [src]="cardView.thumbnail[0].url" alt="">
              </button>
            </div>

            <div class="media-previews-row" *ngIf="cardView.media?.length">
              <div class="media-preview" *ngFor="let media of cardView.media">
                <img *ngIf="media.type === 'image' || media.type === 'webimage'"
                  (click)="setDefaultMedia(cardView.media, media.name, getCardAuthorName(cardView))" [src]="media.url" alt="">
                <video *ngIf="media.type === 'video'" [src]="media.url"
                  (click)="setDefaultMedia(cardView.media, media.name, getCardAuthorName(cardView))"></video>
                <iframe *ngIf="media.type === 'webvideo'"
                  [src]="'https://www.youtube.com/embed/' + media.url | safe" frameborder="0"></iframe>
                <img *ngIf="media.type === 'csv'" src="assets/images/media/csv.svg"
                  (click)="setDefaultMedia(cardView.media, media.name, getCardAuthorName(cardView))" alt="csv">
                <img *ngIf="media.type === 'sheet'" src="assets/images/media/excel.svg"
                  (click)="setDefaultMedia(cardView.media, media.name, getCardAuthorName(cardView))" alt="xlsx">
                <img *ngIf="media.type === 'ppt'" src="assets/images/media/ppt.svg"
                  (click)="setDefaultMedia(cardView.media, media.name, getCardAuthorName(cardView))" alt="ppt">
                <img *ngIf="media.type === 'pdf'" src="assets/images/media/pdf.svg"
                  (click)="setDefaultMedia(cardView.media, media.name, getCardAuthorName(cardView))" alt="pdf">
                <button type="button" class="card-audio-tile" *ngIf="media.type === 'audio'"
                  (click)="setDefaultMedia(cardView.media, media.name, getCardAuthorName(cardView))">
                  <span class="card-audio-icon" aria-hidden="true">
                    <span class="material-symbols-outlined">graphic_eq</span>
                  </span>
                  <span class="card-audio-copy">
                    <span class="card-audio-label">{{ 'gameLabel.Audio' | translate }}</span>
                    <span class="card-audio-from">{{ 'gameLabel.Audio_from' | translate: { name: getCardAuthorName(cardView) } }}</span>
                  </span>
                  <span class="card-audio-play" aria-hidden="true">
                    <span class="material-symbols-outlined">play_arrow</span>
                  </span>
                </button>
              </div>
            </div>

            <div class="view-card-sdg" *ngIf="cardView.sdg_tags?.length">
              <button type="button" class="view-card-sdg-item" *ngFor="let sdg of cardView.sdg_tags"
                (click)="sdgView(cardView.sdg_tags)">
                <img src="assets/images/sdgicon/sdg{{sdg}}_{{commonService.selectedlang}}.png" alt="">
              </button>
            </div>
          </div>

          <div class="view-card-reactions">
            <div class="emotion-icon-container" *ngIf="cardView.showReactionEdit">
              <div class="icon-box mojiFont text-center">
                <span [class.selected]="selectedReaction === 'like'" (click)="setReaction('like',cardView)">👍</span>
              </div>
              <div class="icon-box mojiFont text-center">
                <span [class.selected]="selectedReaction === 'love'" (click)="setReaction('love',cardView)">❤️</span>
              </div>
              <div class="icon-box mojiFont text-center">
                <span [class.selected]="selectedReaction === 'haha'" (click)="setReaction('haha',cardView)">😂</span>
              </div>
              <div class="icon-box mojiFont text-center">
                <span [class.selected]="selectedReaction === 'wow'" (click)="setReaction('wow',cardView)">😮</span>
              </div>
              <div class="icon-box mojiFont text-center">
                <span [class.selected]="selectedReaction === 'sad'" (click)="setReaction('sad',cardView)">😢</span>
              </div>
              <div class="icon-box mojiFont text-center">
                <span [class.selected]="selectedReaction === 'angry'" (click)="setReaction('angry',cardView)">😡</span>
              </div>
            </div>
            <div class="emotions-icon-containetr-popup">
              <div class="icon-box-popup overlap-margin pointer" *ngFor="let reaction of cardView.lastThreeReaction"
                data-bs-toggle="modal" data-bs-target="#reactionModel"
                (click)="reactionModel(cardView.reactions,cardView)">
                <span class="emogiFontDisplay" *ngIf="reaction.type==='like'">👍</span>
                <span class="emogiFontDisplay" *ngIf="reaction.type==='love'">❤️</span>
                <span class="emogiFontDisplay" *ngIf="reaction.type==='haha'">😂</span>
                <span class="emogiFontDisplay" *ngIf="reaction.type==='wow'">😮</span>
                <span class="emogiFontDisplay" *ngIf="reaction.type==='sad'">😢</span>
                <span class="emogiFontDisplay" *ngIf="reaction.type==='angry'">😡</span>
              </div>
              <div class="icon-box-popup overlap-right-plus pointer" *ngIf="cardView.reactionCount>3"
                data-bs-toggle="modal" data-bs-target="#reactionModel"
                (click)="reactionModel(cardView.reactions,cardView)">
                <p>+{{cardView.reactionCount}}</p>
              </div>
              <button class="view-card-react-btn {{cardView.reactionIconClass}}" type="button"
                (click)="clickReactionEdit(cardView)">
                <span class="material-symbols-outlined">sentiment_satisfied</span>
              </button>
            </div>
            <div class="view-card-rating" *ngIf="boardService.assignmentId>0">
              <ngb-rating [max]=5 [(rate)]="cardView.cardRating" [readonly]="true"
                *ngIf="!boardService.cardRating"></ngb-rating>
              <ngb-rating [max]=5 [(rate)]="cardView.cardRating" (rateChange)="getValue(cardView,cardView.cardRating)"
                *ngIf="boardService.cardRating"></ngb-rating>
            </div>
          </div>

          <section class="view-card-comments rl-thread">
            <div class="view-card-comments-head">
              <h5>{{ 'gameLabel.Comment' | translate }}</h5>
              <span class="view-card-comments-count">{{ cardView.cardComment.length }}</span>
            </div>

            <div class="view-card-comment-list" *ngIf="cardView.cardComment.length; else viewCardNoComments">
              <article class="view-card-comment" *ngFor="let comment of cardView.cardComment">
                <span class="avatar sm">{{ getInitials(comment.name) }}</span>
                <div class="view-card-comment-body">
                  <div class="view-card-comment-meta">
                    <strong>{{ comment.name }}</strong>
                    <time>{{ commonService.calculateHours(comment.id) }}</time>
                    <div class="view-card-comment-actions"
                      *ngIf="comment.user_id===commonService.userId && !comment.editCommentFlag">
                      <button type="button" (click)="editClick(comment)"
                        [attr.aria-label]="'gameLabel.Edit' | translate">
                        <span class="material-symbols-outlined">edit</span>
                      </button>
                      <button type="button" class="is-danger"
                        (click)="deleteCommentConfirm(cardView.cardId,comment.id,cardView.sectionId)"
                        [attr.aria-label]="'gameLabel.Delete' | translate">
                        <span class="material-symbols-outlined">delete</span>
                      </button>
                    </div>
                  </div>
                  <p class="view-card-comment-text" *ngIf="!comment.editCommentFlag">{{ comment.text }}</p>
                  <div class="view-card-comment-editor"
                    *ngIf="comment.editCommentFlag && editCommentId===comment.id">
                    <input type="text" [(ngModel)]="editCommentText"
                      [placeholder]="'gameLabel.Add_comment' | translate"
                      (keyup.enter)="editComment(cardView.cardId,cardView.sectionId)">
                    <button type="button" (click)="cancelEditComment(comment)" aria-label="Cancel">
                      <span class="material-symbols-outlined">close</span>
                    </button>
                    <button type="button" class="is-save"
                      (click)="editComment(cardView.cardId,cardView.sectionId)"
                      [disabled]="comment.text===editCommentText || editCommentText===''">
                      <span class="material-symbols-outlined">check</span>
                    </button>
                  </div>
                </div>
              </article>
            </div>
            <ng-template #viewCardNoComments>
              <p class="view-card-comments-empty">{{ 'gameLabel.No_comments' | translate }}</p>
            </ng-template>
          </section>
        </div>

        <div class="view-card-composer">
          <span class="avatar sm">{{ getInitials(commonService.user?.name) }}</span>
          <label class="view-card-composer-box">
            <input type="text" [(ngModel)]="cardView.commentText"
              [placeholder]="'gameLabel.Add_comment' | translate"
              (keyup.enter)="saveComment(cardView.commentText,cardView.cardId,cardView.cardComment.length,cardView.sectionId)">
            <button type="button" [disabled]="!cardView.commentText"
              (click)="saveComment(cardView.commentText,cardView.cardId,cardView.cardComment.length,cardView.sectionId)">
              <span class="material-symbols-outlined">send</span>
            </button>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- view-card-model-end -->


<!-- view-thumbnail-start -->
<div class="modal fade" id="screenshotView" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered w1000" role="document">
    <div class="modal-content">
      <div class="modal-header" style="padding: 0.5rem 0.5rem;">
        <h5 class="modal-title" id="exampleModalLabel">
          {{ "gameLabel.Thumbnail_view" | translate }}
        </h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body p-0">
        <div class="col-md-12 d-flex justify-content-center align-items-center">
          <img [src]="thumbnailImage" style="height: 100%;width: 100%;" />
        </div>
      </div>
    </div>
  </div>
</div>
<!-- view-thumbnail-end -->


<!-- view-sdg-tag-start -->
<div class="modal fade" id="sdgImagView" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered w1000" role="document">
    <div class="modal-content">
      <div class="modal-header" style="padding: 0.5rem 0.5rem;">
        <h5 class="modal-title" id="exampleModalLabel">
         {{'gameLabel.Taged_sdg'|translate}}
        </h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body p-0">
        <div class="col-md-12 d-flex" style="justify-content: space-between;text-align: center;">
          <div class="row">
            <div class="col-md-6" *ngFor="let sdg of tagSdg">
              <img src="assets/images/sdgicon/sdg{{sdg}}_{{commonService.selectedlang}}.png" alt=""
                style="width: 80%;border: 1px solid gray ;border-radius: 8px;">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- view-sdg-tag-end -->

<!-- Audio recording start -->
<div class="modal fade" id="audioRecording" tabindex="-1" aria-labelledby="audioRecordingLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered audio-record-dialog">
    <div class="modal-content audio-record-content">
      <header class="audio-record-header">
        <div class="audio-record-title-row">
          <div class="audio-record-icon" aria-hidden="true">
            <span class="material-symbols-outlined">mic</span>
          </div>
          <div class="audio-record-heading">
            <h4 id="audioRecordingLabel">{{ "gameLabel.Audio_Recording" | translate }}</h4>
            <p>{{ "gameLabel.Audio" | translate }}</p>
          </div>
        </div>
        <button class="audio-record-close" type="button" data-bs-dismiss="modal" aria-label="Close"
          (click)="clearRecordedData()">
          <span class="material-symbols-outlined">close</span>
        </button>
      </header>

      <div class="audio-record-body" [class.is-live]="isRecording">
        <div class="audio-record-visual">
          <span class="audio-record-pulse" aria-hidden="true"></span>
          <span class="audio-record-pulse is-delayed" aria-hidden="true"></span>
          <div class="audio-record-mic">
            <span class="material-symbols-outlined">graphic_eq</span>
          </div>
        </div>

        <div class="audio-record-time">{{ recordedTime || '00:00' }}</div>
        <div class="audio-record-status">
          <span class="audio-record-dot" aria-hidden="true"></span>
          {{ "gameLabel.REC" | translate }}
        </div>

        <div class="audio-record-wave" aria-hidden="true">
          <span *ngFor="let level of audioLevels; trackBy: trackWaveBar"
            [style.height.px]="waveBarHeight(level)"></span>
        </div>

        <p class="audio-record-hint" *ngIf="convertToSeconds(recordedTime) <= 0">
          {{ 'gameLabel.autio-permission' | translate }}
        </p>
      </div>

      <div class="audio-record-actions">
        <button type="button" class="audio-record-btn is-ghost" data-bs-dismiss="modal"
          (click)="clearRecordedData()">
          {{ "gameLabel.Close" | translate }}
        </button>
        <button type="button" class="audio-record-btn" data-bs-dismiss="modal"
          [disabled]="convertToSeconds(recordedTime) <= 0" (click)="stopRecording()">
          {{ "gameLabel.Save" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Audio recording end -->

<!-- Websearch start -->
<div class="modal fade" id="webSearch" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
    <div class="modal-content audioWindowRecording animate__animated animate__bounceIn">
      <div class="modal-header">
        <h4 class="modal-title" id="exampleModalLabel">
          {{ "gameLabel.Search_image_and_video" | translate }}
        </h4>
      </div>
      <div class="modal-body text-center">
        <div style="position: relative; display: flex; align-items: center; width: 100%;">
          <input type="text" style="width: 100%; padding-right: 30px;" [(ngModel)]="search" placeholder="Search images and videos..." (keyup.enter)="searchWeb()" />
          <i class="fa-solid fa-magnifying-glass" (click)="searchWeb()" style="position: absolute; right: 10px; cursor: pointer;"></i>
        </div>

        <div class="nav nav-tabs d-flex mt-4" id="nav-tab" role="tablist">
          <a class="w-100 nav-item nav-link {{ imageActive }}" style="flex: 1" (click)="imageTab()">
            {{ "gameLabel.Images" | translate }}
          </a>
          <a class="w-100 nav-item nav-link {{ videoActive }}" style="flex: 1" (click)="videoTab()">
            {{ "gameLabel.Youtube" | translate }}
          </a>
        </div>
        <div class="tab-content">
          <div *ngIf="imageSearchFlag" class="tab-pane fade show {{ imageActive }}">
            <!-- Content for Images tab -->
            <div class="results">
              <div *ngFor="let image of imagesSerach" class="result-item" (click)="selectImageForWebSearch(image)"
                [class.selected]="isSelectedImage(image)">
                <img [src]="image.link | safe" [alt]="image.title" />
              </div>
            </div>
          </div>
          <div *ngIf="videoSearchFlag" class="tab-pane fade show {{ videoActive }}">
            <!-- Content for YouTube tab -->
            <div class="results">
              <div *ngFor="let video of videosSearch" class="result-item" [class.selected]="isSelectedVideo(video)"
                (click)="selectVideo(video)">
                <iframe [src]="  
                    'https://www.youtube.com/embed/' + video.id.videoId | safe
                  " frameborder="0" allowfullscreen ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeWebSerach()">
          {{ "gameLabel.Close" | translate }}
        </button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="saveWebSearchVideo()">
          {{ "gameLabel.Save" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Websearch end -->

<!-- inviteruser start -->
<div class="modal fade" id="inviteUser" tabindex="-1" aria-labelledby="inviteUserLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="container-invite-modal">
        <header class="invite-modal-header">
          <div class="invite-modal-title-row">
            <div class="invite-modal-icon" aria-hidden="true">
              <span class="material-symbols-outlined">person_add</span>
            </div>
            <div class="invite-modal-heading">
              <h4 id="inviteUserLabel">{{ 'gameLabel.Search_for_Users_to_invite' | translate }}</h4>
              <p>{{ 'gameLabel.Invite_subtitle' | translate }}</p>
            </div>
          </div>
          <button class="invite-modal-close" type="button" data-bs-dismiss="modal" aria-label="Close"
            (click)="closeInvitation()">
            <span class="invite-modal-close-inner">
              <span class="material-symbols-outlined">close</span>
            </span>
          </button>
        </header>

        <div class="invite-modal-body" *ngIf="commonService.user.drole !== 'Gamer'">
          <label class="invite-search">
            <span class="material-symbols-outlined" aria-hidden="true">search</span>
            <input type="text" [(ngModel)]="searchInviterUser"
              [placeholder]="'gameLabel.Search_users_placeholder' | translate"
              (input)="sendInvitation()">
          </label>

          <div class="invite-selected" *ngIf="selectedUsers.length">
            <p class="invite-section-label">
              <span class="material-symbols-outlined" aria-hidden="true">group</span>
              {{ selectedUsers.length }} {{ 'gameLabel.Selected' | translate }}
            </p>
            <div class="invite-chip-row">
              <button class="invite-chip" type="button" *ngFor="let user of selectedUsers"
                (click)="removeSelectedUser(user)">
                <span class="invite-chip-avatar">{{ getInitials(user.name || user.username || user.email) }}</span>
                <span>{{ user.name || user.username || user.email }}</span>
                <span class="material-symbols-outlined">close</span>
              </button>
            </div>
          </div>

          <ng-container *ngIf="boardService.users | inviterUserFilter:searchInviterUser as filteredUsers">
            <div class="invite-empty" *ngIf="!filteredUsers.length">
              {{ 'gameLabel.No_users_found' | translate }}
            </div>
            <div class="invite-user-list" *ngIf="filteredUsers.length">
              <div class="invite-user-row" *ngFor="let user of filteredUsers"
                [class.is-selected]="isSelected(user)" (click)="toggleSelection(user)">
                <button class="invite-user-check" type="button"
                  [attr.aria-pressed]="isSelected(user)">
                  <span class="material-symbols-outlined">
                    {{ isSelected(user) ? 'check_box' : 'check_box_outline_blank' }}
                  </span>
                </button>
                <span class="invite-user-avatar">{{ getInitials(user.name || user.username || user.email) }}</span>
                <div class="invite-user-copy">
                  <p class="invite-user-name">{{ user.name || user.username || user.email }}</p>
                  <p class="invite-user-meta">
                    <span *ngIf="user.username">{{ user.username }}</span>
                    <span *ngIf="user.drole">{{ user.drole }}</span>
                    <span *ngIf="user.email">{{ user.email }}</span>
                  </p>
                </div>
                <label class="invite-perm" (click)="$event.stopPropagation()">
                  <span>{{ 'gameLabel.Permissions' | translate }}</span>
                  <select [value]="getInvitePermission(user)" (change)="updateAdminAccess(user, $event)"
                    (click)="$event.stopPropagation()">
                    <option value="admin">{{ 'gameLabel.Admin' | translate }}</option>
                    <option value="write">{{ 'gameLabel.Write' | translate }}</option>
                    <option value="read">{{ 'gameLabel.Read' | translate }}</option>
                  </select>
                </label>
              </div>
            </div>
          </ng-container>
        </div>

        <form class="invite-modal-body invite-gamer-form" *ngIf="commonService.user.drole === 'Gamer'"
          #searchForm="ngForm" (ngSubmit)="onSubmit(searchForm)">
          <label class="invite-section-label" for="inviterUserEmail">
            <span class="material-symbols-outlined" aria-hidden="true">mail</span>
            {{ 'gameLabel.Enter_email_addresses' | translate }}
          </label>
          <textarea id="inviterUserEmail" name="inviterUserEmail" ngModel #inviterUserEmail="ngModel" required
            [placeholder]="'gameLabel.Enter_emails_placeholder' | translate"
            pattern="^(([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}),\s*)*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"></textarea>
          <p class="invite-field-error" *ngIf="inviterUserEmail.invalid && (inviterUserEmail.dirty || inviterUserEmail.touched)">
            <span *ngIf="inviterUserEmail.errors?.['required']">{{ 'gameLabel.Email_is_required' | translate }}</span>
            <span *ngIf="inviterUserEmail.errors?.['pattern']">
              {{ 'gameLabel.Enter_valid_email_addresses_separated_by_commas' | translate }}
            </span>
          </p>
          <label class="invite-section-label" for="gamerPermission">
            <span class="material-symbols-outlined" aria-hidden="true">lock</span>
            {{ 'gameLabel.Select_permissions_for_selected_users' | translate }}
          </label>
          <select id="gamerPermission" class="invite-gamer-perm" (change)="updateAdminAccessGamer($event)">
            <option value="admin">{{ 'gameLabel.Admin' | translate }}</option>
            <option value="write">{{ 'gameLabel.Write' | translate }}</option>
            <option value="read">{{ 'gameLabel.Read' | translate }}</option>
          </select>
          <div class="invite-modal-footer">
            <button type="button" class="invite-btn-reset" data-bs-dismiss="modal" (click)="closeModal('inviteUser')">
              {{ 'gameLabel.Close' | translate }}
            </button>
            <button type="submit" class="invite-btn-apply" [disabled]="searchForm.invalid"
              (click)="sendInvitationToList(inviterUserEmail.value)">
              {{ 'gameLabel.Send_invitation' | translate }}
            </button>
          </div>
        </form>

        <div class="invite-modal-footer" *ngIf="commonService.user.drole !== 'Gamer'">
          <button type="button" class="invite-btn-reset" data-bs-dismiss="modal" (click)="closeInvitation()">
            {{ 'gameLabel.Close' | translate }}
          </button>
          <button type="button" class="invite-btn-apply" [disabled]="selectedUsers.length === 0"
            (click)="sendInvitationToList('')">
            {{ 'gameLabel.Send_invitation' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- inviteruser end -->


<!-- filter start -->
<div class="modal fade" id="filterOption" tabindex="-1" aria-labelledby="filterOptionLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="container-filter-modal">
        <header class="filter-modal-header">
          <div class="filter-modal-title-row">
            <div class="filter-modal-icon" aria-hidden="true">
              <span class="material-symbols-outlined">filter_list</span>
            </div>
            <div class="filter-modal-heading">
              <h4 id="filterOptionLabel">{{ 'gameLabel.card_filter' | translate }}</h4>
              <p>{{ 'gameLabel.Filter_subtitle' | translate }}</p>
            </div>
          </div>
          <button class="filter-modal-close" type="button" data-bs-dismiss="modal" aria-label="Close">
            <span class="filter-modal-close-inner">
              <span class="material-symbols-outlined">close</span>
            </span>
          </button>
        </header>

        <div class="filter-modal-body" *ngIf="commonService.user.drole !== 'Gamer'">
          <div class="filter-section">
            <p class="filter-section-label">
              <span class="material-symbols-outlined" aria-hidden="true">tune</span>
              {{ 'gameLabel.Common_filter' | translate }}
            </p>
            <div class="filter-chip-row">
              <button class="filter-chip" type="button"
                [class.is-selected]="selectedUser === 'dummy'"
                (click)="selectUser('dummy')">
                <span class="material-symbols-outlined" aria-hidden="true">chat</span>
                {{ 'gameLabel.Most_commentd_card' | translate }}
              </button>
              <button class="filter-chip" type="button"
                [class.is-selected]="selectedUser === 'reacted'"
                (click)="selectUser('reacted')">
                <span class="material-symbols-outlined" aria-hidden="true">favorite</span>
                {{ 'gameLabel.Most_reacted_card' | translate }}
              </button>
            </div>
          </div>

          <div class="filter-section">
            <p class="filter-section-label">
              <span class="material-symbols-outlined" aria-hidden="true">group</span>
              {{ 'gameLabel.Filter_by_user' | translate }}
            </p>
            <div class="filter-chip-row" *ngIf="boardService.cardOwnerListDummy?.length; else noFilterUsers">
              <button class="filter-chip filter-user-chip" type="button"
                *ngFor="let user of boardService.cardOwnerListDummy"
                [class.is-selected]="selectedUser === user.username"
                (click)="selectUser(user.username)">
                <span class="filter-user-avatar">
                  {{ getInitials(user.name || user.username) }}
                </span>
                <span>{{ (user.name && user.name.trim()) ? user.name : user.username }}</span>
                <span class="filter-user-count">{{ user.card_count }}</span>
              </button>
            </div>
            <ng-template #noFilterUsers>
              <div class="filter-empty">{{ 'gameLabel.No_users_to_filter' | translate }}</div>
            </ng-template>
          </div>
        </div>

        <div class="filter-modal-footer" *ngIf="commonService.user.drole !== 'Gamer'">
          <button class="filter-btn-reset" type="button" (click)="resetFilter()">
            {{ 'gameLabel.Reset' | translate }}
          </button>
          <button class="filter-btn-apply" type="button" data-bs-dismiss="modal"
            (click)="setFilter()" [disabled]="selectedUser === ''">
            <span class="material-symbols-outlined" aria-hidden="true">check</span>
            {{ 'gameLabel.Set_filter' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- filter-end -->

<!-- view all reactions -->
<div class="modal fade" id="reactionModel" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content animate__animated animate__backInLeft">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">{{'gameLabel.All_reactions_list'|translate}}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body modal-reaction-body">

        <div class="tab-container-main">
          <div class="tab-heder-container">
            <div class="add-number-icon-box" [class.active]="i === reactionActiveTabIndex" (click)="selectTab(i)"
              *ngFor="let tab of reactionTab; let i = index">
              <!-- <div class="icon-logo-reaction"> -->
                <span class="emogiFont" *ngIf="tab.type==='like'">👍</span>
                <span class="emogiFont" *ngIf="tab.type==='love'">❤️</span>
                <span class="emogiFont" *ngIf="tab.type==='haha'">😂</span>
                <span class="emogiFont" *ngIf="tab.type==='wow'">😮</span>
                <span class="emogiFont" *ngIf="tab.type==='sad'">😢</span>
                <span class="emogiFont" *ngIf="tab.type==='angry'">😡</span>
              <!-- </div> -->
              <p style="margin-bottom: 0px!important;">{{tab.count}}</p>
            </div>
          </div>
          <div class="tab-container-scroll">
            <div class="icon-data-deffrent-container" *ngIf="reactionTab[reactionActiveTabIndex]" style="width: 100%;">
              <div class="user-data-container" *ngFor="let list of reactionTab[reactionActiveTabIndex].content" style="display: flex; justify-content: space-between;">
                <div style="display: flex;justify-content: space-between;">
                  <div class="user-logo-icon">
                    <div class="smoll-user-logo-child-icon">
                      <span *ngIf="list.type==='like'">👍</span>
                    <span *ngIf="list.type==='love'">❤️</span>
                    <span *ngIf="list.type==='haha'">😂</span>
                    <span *ngIf="list.type==='wow'">😮</span>
                    <span *ngIf="list.type==='sad'">😢</span>
                    <span *ngIf="list.type==='angry'">😡</span>
                    </div>
                    <img src="{{list.avatar}}" alt="">
                  </div>
                  <div class="name-followers-container">
                    <div class="text-name-user-box" style="display: flex;justify-content: space-between;align-items: center;">
                      <p class="user-name-text">{{list.name}}</p>
                     
                    </div>
                  </div>
                </div>
                <i placement="top" ngbtooltip="Delete Chat" class="fe-trash-2 font-edit-class" ng-reflect-placement="top"  *ngIf="list.user_id===commonService.user.id" style="cursor: pointer;"
                ng-reflect-ngb-tooltip="Delete Chat" (click)="removeReaction()"></i>
              </div>
            </div>
            
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<!-- view all-reaction-end -->


<div class="modal fade" id="profile" tabindex="-1" aria-labelledby="profileModalLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="container-profile-modal">
        <header class="profile-modal-header">
          <div class="profile-modal-title-row">
            <div class="profile-modal-icon" aria-hidden="true">
              <span class="material-symbols-outlined">person</span>
            </div>
            <div class="profile-modal-heading">
              <h4 id="profileModalLabel">{{ 'gameLabel.User_Profile' | translate }}</h4>
              <p>{{ 'gameLabel.Profile_subtitle' | translate }}</p>
            </div>
          </div>
          <button class="profile-modal-close" type="button" data-bs-dismiss="modal" aria-label="Close">
            <span class="profile-modal-close-inner">
              <span class="material-symbols-outlined">close</span>
            </span>
          </button>
        </header>

        <div class="profile-modal-body">
          <div class="profile-hero">
            <span class="profile-avatar">
              {{ getInitials(commonService.user?.name) }}
            </span>
            <div class="profile-hero-text">
              <h3 class="profile-hero-name">{{ commonService.user?.name }}</h3>
              <span class="profile-role-pill" *ngIf="commonService.user?.drole">
                {{ commonService.user.drole }}
              </span>
              <p class="profile-username" *ngIf="commonService.user?.username">
                {{ 'gameLabel.Username' | translate }}: {{ commonService.user.username }}
              </p>
            </div>
          </div>

          <div class="profile-details">
            <div class="profile-detail-row">
              <span class="profile-detail-icon" aria-hidden="true">
                <span class="material-symbols-outlined">school</span>
              </span>
              <div class="profile-detail-copy">
                <span class="profile-detail-label">{{ 'gameLabel.School_name' | translate }}</span>
                <span class="profile-detail-value"
                  [class.is-empty]="!commonService.user?.sch_name">
                  {{ commonService.user?.sch_name || ('gameLabel.Not_available' | translate) }}
                </span>
              </div>
            </div>

            <div class="profile-detail-row" *ngIf="commonService.user?.email">
              <span class="profile-detail-icon" aria-hidden="true">
                <span class="material-symbols-outlined">mail</span>
              </span>
              <div class="profile-detail-copy">
                <span class="profile-detail-label">{{ 'gameLabel.Email' | translate }}</span>
                <span class="profile-detail-value">{{ commonService.user.email }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- media-view-start -->
<div class="modal fade" id="mediaView" tabindex="-1" aria-labelledby="mediaViewLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered rl-lightbox-dialog">
    <div class="modal-content rl-lightbox-content">
      <button type="button" class="rl-lightbox-close" data-bs-dismiss="modal" aria-label="Close"
        (click)="closeModal('mediaView')">
        <span class="material-symbols-outlined">close</span>
      </button>

      <div class="rl-lightbox-stage">
        <button type="button" class="rl-lightbox-nav"
          *ngIf="boardService.selectedMedia?.length > 1"
          [class.disabled]="cssForDisableArrowsPre === 'disabled'"
          [disabled]="cssForDisableArrowsPre === 'disabled'"
          (click)="previousEvent()"
          aria-label="Previous">
          <span class="material-symbols-outlined">chevron_left</span>
        </button>

        <div class="rl-lightbox-frame">
          <img *ngIf="boardService.curretnSelectedMedia.type === 'image' || boardService.curretnSelectedMedia.type === 'webimage'"
            [src]="boardService.curretnSelectedMedia.url" alt="">

          <video #videoPlayer *ngIf="boardService.curretnSelectedMedia.type === 'video'" controls>
            <source [src]="boardService.curretnSelectedMedia.url" type="video/mp4">
            Your browser does not support the video tag.
          </video>

          <div class="rl-lightbox-embed" *ngIf="boardService.curretnSelectedMedia.type === 'webvideo'">
            <iframe [src]="'https://www.youtube.com/embed/' + boardService.curretnSelectedMedia.url | safe"
              frameborder="0" allowfullscreen></iframe>
          </div>

          <div class="rl-lightbox-audio" *ngIf="boardService.curretnSelectedMedia.type === 'audio'">
            <div class="rl-now-playing">
              <div class="rl-now-playing-icon" [class.is-playing]="lightboxAudioPlaying" aria-hidden="true">
                <span class="material-symbols-outlined">graphic_eq</span>
              </div>
              <div class="rl-now-playing-copy">
                <p>{{ 'gameLabel.Now_playing' | translate }}</p>
                <h4 *ngIf="boardService.currentMediaOwnerName">
                  {{ 'gameLabel.Audio_from' | translate: { name: boardService.currentMediaOwnerName } }}
                </h4>
                <h4 *ngIf="!boardService.currentMediaOwnerName">
                  {{ 'gameLabel.Audio' | translate }}
                </h4>
              </div>
            </div>
            <audio #audioPlayernew
              [src]="boardService.curretnSelectedMedia.url"
              preload="metadata"
              (timeupdate)="onLightboxAudioTime()"
              (loadedmetadata)="onLightboxAudioMeta()"
              (ended)="onLightboxAudioEnded()"
              (play)="onLightboxAudioPlay()"
              (pause)="onLightboxAudioPause()">
            </audio>
            <div class="rl-audio-player">
              <button type="button" class="rl-audio-play" (click)="toggleLightboxAudioPlay()"
                [attr.aria-label]="lightboxAudioPlaying ? 'Pause' : 'Play'">
                <span class="material-symbols-outlined">{{ lightboxAudioPlaying ? 'pause' : 'play_arrow' }}</span>
              </button>
              <div class="rl-audio-timeline">
                <input type="range" class="rl-audio-seek" min="0" step="0.05"
                  [max]="lightboxAudioDuration || 0"
                  [value]="lightboxAudioCurrent"
                  [style.--progress]="lightboxAudioProgress + '%'"
                  (input)="seekLightboxAudio($event)"
                  aria-label="Seek">
                <div class="rl-audio-times">
                  <span>{{ formatLightboxTime(lightboxAudioCurrent) }}</span>
                  <span>{{ formatLightboxTime(lightboxAudioDuration) }}</span>
                </div>
              </div>
              <div class="rl-audio-vol">
                <button type="button" class="rl-audio-mute" (click)="toggleLightboxMute()"
                  [attr.aria-label]="lightboxAudioMuted || lightboxAudioVolume === 0 ? 'Unmute' : 'Mute'">
                  <span class="material-symbols-outlined">{{ lightboxVolumeIcon() }}</span>
                </button>
                <input type="range" class="rl-audio-vol-slider" min="0" max="1" step="0.01"
                  [value]="lightboxAudioMuted ? 0 : lightboxAudioVolume"
                  [style.--progress]="(lightboxAudioMuted ? 0 : lightboxAudioVolume * 100) + '%'"
                  (input)="setLightboxVolume($event)"
                  aria-label="Volume">
              </div>
            </div>
          </div>

          <div class="rl-lightbox-file"
            *ngIf="boardService.curretnSelectedMedia.url && (boardService.curretnSelectedMedia.url.includes('xlsx') || boardService.curretnSelectedMedia.url.includes('ppt') || boardService.curretnSelectedMedia.url.includes('csv'))">
            <p>{{'gameLabel.xlsx_file_Warr' | translate}}</p>
            <a [href]="boardService.curretnSelectedMedia.url">
              <span class="material-symbols-outlined">download</span>
            </a>
          </div>

          <div class="rl-lightbox-embed is-pdf" *ngIf="boardService.curretnSelectedMedia.type === 'pdf'">
            <iframe [src]="boardService.curretnSelectedMedia.url | safe"></iframe>
          </div>
        </div>

        <button type="button" class="rl-lightbox-nav"
          *ngIf="boardService.selectedMedia?.length > 1"
          [class.disabled]="cssForDisableArrowsNext === 'disabled'"
          [disabled]="cssForDisableArrowsNext === 'disabled'"
          (click)="nextEvent()"
          aria-label="Next">
          <span class="material-symbols-outlined">chevron_right</span>
        </button>
      </div>

      <p class="rl-lightbox-counter" *ngIf="boardService.selectedMedia?.length > 1">
        {{ getSelectedMediaIndex() + 1 }} / {{ boardService.selectedMedia.length }}
      </p>
    </div>
  </div>
</div>
<!-- media-view-end -->


<!-- view all comments -->
<div class="modal fade" id="commentModel" tabindex="-1" aria-labelledby="commentModelLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="container-modal-first">
        <header class="header-style-add-board">
          <div class="title-id-content">
            <div class="icon-board-label">
              <span class="material-symbols-outlined">chat</span>
            </div>
            <div class="title-desc-board">
              <h4 class="title-add-board" id="commentModelLabel">{{ 'gameLabel.All_comments' | translate }}</h4>
            </div>
          </div>
          <button class="cancel-icon-board" type="button" data-bs-dismiss="modal" aria-label="Close">
            <span class="icon-cancel">
              <span class="material-symbols-outlined">close</span>
            </span>
          </button>
        </header>

        <div class="section-modal-body">
          <section class="view-card-comments rl-thread">
            <div class="view-card-comments-head">
              <h5>{{ 'gameLabel.Comment' | translate }}</h5>
              <span class="view-card-comments-count">{{ cardComment.cardComment?.length || 0 }}</span>
            </div>

            <div class="view-card-comment-list" *ngIf="cardComment.cardComment?.length; else allCommentsEmpty">
              <article class="view-card-comment" *ngFor="let comment of cardComment.cardComment">
                <span class="avatar sm">{{ getInitials(comment.name) }}</span>
                <div class="view-card-comment-body">
                  <div class="view-card-comment-meta">
                    <strong>{{ comment.name }}</strong>
                    <time>{{ commonService.calculateHours(comment.id) }}</time>
                    <div class="view-card-comment-actions"
                      *ngIf="comment.user_id===commonService.userId && !comment.editCommentFlag">
                      <button type="button" (click)="editClick(comment)"
                        [attr.aria-label]="'gameLabel.Edit' | translate">
                        <span class="material-symbols-outlined">edit</span>
                      </button>
                      <button type="button" class="is-danger"
                        (click)="deleteCommentConfirm(cardComment.cardId,comment.id,cardComment.sectionId)"
                        [attr.aria-label]="'gameLabel.Delete' | translate">
                        <span class="material-symbols-outlined">delete</span>
                      </button>
                    </div>
                  </div>
                  <p class="view-card-comment-text" *ngIf="!comment.editCommentFlag">{{ comment.text }}</p>
                  <div class="view-card-comment-editor"
                    *ngIf="comment.editCommentFlag && editCommentId===comment.id">
                    <input type="text" [(ngModel)]="editCommentText"
                      [placeholder]="'gameLabel.Add_comment' | translate"
                      (keyup.enter)="editComment(cardComment.cardId,cardComment.sectionId)">
                    <button type="button" (click)="cancelEditComment(comment)" aria-label="Cancel">
                      <span class="material-symbols-outlined">close</span>
                    </button>
                    <button type="button" class="is-save"
                      (click)="editComment(cardComment.cardId,cardComment.sectionId)"
                      [disabled]="comment.text===editCommentText || editCommentText===''">
                      <span class="material-symbols-outlined">check</span>
                    </button>
                  </div>
                </div>
              </article>
            </div>
            <ng-template #allCommentsEmpty>
              <p class="view-card-comments-empty">{{ 'gameLabel.No_comments' | translate }}</p>
            </ng-template>
          </section>
        </div>

        <div class="view-card-composer">
          <span class="avatar sm">{{ getInitials(commonService.user?.name) }}</span>
          <label class="view-card-composer-box">
            <input type="text" [(ngModel)]="cardComment.commentText"
              [placeholder]="'gameLabel.Add_comment' | translate"
              (keyup.enter)="saveComment(cardComment.commentText,cardComment.cardId,cardComment.cardComment.length,cardComment.sectionId)">
            <button type="button" [disabled]="!cardComment.commentText"
              (click)="saveComment(cardComment.commentText,cardComment.cardId,cardComment.cardComment.length,cardComment.sectionId)">
              <span class="material-symbols-outlined">send</span>
            </button>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- view all-comments-end -->


<div class="modal fade" id="confirm1" tabindex="-1" role="dialog" aria-labelledby="confirm1Title" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content rl-alert-content">
      <div class="rl-alert-body">
        <div class="rl-alert-icon is-warning" aria-hidden="true">
          <span class="material-symbols-outlined">info</span>
        </div>
        <p class="rl-alert-text" id="confirm1Title">{{ msgText }}</p>
      </div>
      <div class="rl-alert-actions">
        <button type="button" class="rl-alert-btn" data-bs-dismiss="modal">{{'gameLabel.Ok'|translate}}</button>
      </div>
    </div>
  </div>
</div>



<!-- <div class="modal fade" id="confirm1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content animate__animated animate__bounceIn border">
      <div class="modal-body" style="border-top:1px solid black ; border-right:1px solid black ;border-left:1px solid black ;">
        <h3 class="text-center">{{msgText}}</h3>
      </div>
      <div class="modal-footer border">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" >
         {{'gameLabel.Ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div> -->
